export const cfTotalProblems = {
  1: ["A", "B", "C"],
  2: ["A", "B", "C"],
  3: ["A", "B", "C", "D"],
  4: ["A", "B", "C", "D"],
  5: ["A", "B", "C", "D", "E"],
  6: ["A", "B", "C", "D", "E"],
  7: ["A", "B", "C", "D", "E"],
  8: ["A", "B", "C", "D", "E"],
  9: ["A", "B", "C", "D", "E"],
  10: ["A", "B", "C", "D", "E"],
  11: ["A", "B", "C", "D", "E"],
  12: ["A", "B", "C", "D", "E"],
  13: ["A", "B", "C", "D", "E"],
  14: ["A", "B", "C", "D", "E"],
  15: ["A", "B", "C", "D", "E"],
  16: ["A", "B", "C", "D", "E"],
  17: ["A", "B", "C", "D", "E"],
  18: ["A", "B", "C", "D", "E"],
  19: ["A", "B", "C", "D", "E"],
  20: ["A", "B", "C"],
  21: ["A", "B", "C", "D"],
  22: ["A", "B", "C", "D", "E"],
  23: ["A", "B", "C", "D", "E"],
  24: ["A", "B", "C", "D", "E"],
  25: ["A", "B", "C", "D", "E"],
  26: ["A", "B", "C", "D", "E"],
  27: ["A", "B", "C", "D", "E"],
  28: ["A", "B", "C", "D", "E"],
  29: ["A", "B", "C", "D", "E"],
  30: ["A", "B", "C", "D", "E"],
  31: ["A", "B", "C", "D", "E"],
  32: ["A", "B", "C", "D", "E"],
  33: ["A", "B", "C", "D", "E"],
  34: ["A", "B", "C", "D", "E"],
  35: ["A", "B", "C", "D", "E"],
  36: ["A", "B", "C", "D", "E"],
  37: ["A", "B", "C", "D", "E"],
  38: ["A", "B", "C", "D", "E", "F", "G", "H"],
  39: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
  40: ["A", "B", "C", "D", "E"],
  41: ["A", "B", "C", "D", "E"],
  42: ["A", "B", "C", "D", "E"],
  43: ["A", "B", "C", "D", "E"],
  44: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  45: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  46: ["A", "B", "C", "D", "E", "F", "G"],
  47: ["A", "B", "C", "D", "E"],
  48: ["A", "B", "C", "D", "E", "F", "G", "H"],
  49: ["A", "B", "C", "D", "E"],
  50: ["A", "B", "C", "D", "E"],
  51: ["A", "B", "C", "D", "E", "F"],
  52: ["A", "B", "C"],
  53: ["A", "B", "C", "D", "E"],
  54: ["A", "B", "C", "D", "E"],
  55: ["A", "B", "C", "D", "E"],
  56: ["A", "B", "C", "D", "E"],
  57: ["A", "B", "C", "D", "E"],
  58: ["A", "B", "C", "D", "E"],
  59: ["A", "B", "C", "D", "E"],
  60: ["A", "B", "C", "D", "E"],
  61: ["A", "B", "C", "D", "E"],
  62: ["A", "B", "C", "D", "E"],
  63: ["A", "B", "C", "D", "E"],
  64: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  65: ["A", "B", "C", "D", "E"],
  66: ["A", "B", "C", "D", "E"],
  67: ["A", "B", "C", "D", "E"],
  68: ["A", "B", "C", "D", "E"],
  69: ["A", "B", "C", "D", "E"],
  70: ["A", "B", "C", "D", "E"],
  71: ["A", "B", "C", "D", "E"],
  72: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  73: ["A", "B", "C", "D", "E", "F"],
  74: ["A", "B", "C", "D", "E"],
  75: ["A", "B", "C", "D", "E"],
  76: ["A", "B", "C", "D", "E", "F"],
  77: ["A", "B", "C", "D", "E"],
  78: ["A", "B", "C", "D", "E"],
  79: ["A", "B", "C", "D", "E"],
  80: ["A", "B", "C", "D", "E"],
  81: ["A", "B", "C", "D", "E"],
  82: ["A", "B", "C", "D", "E"],
  83: ["A", "B", "C", "D", "E"],
  84: ["A", "B", "C", "D", "E"],
  85: ["A", "B", "C", "D", "E"],
  86: ["A", "B", "C", "D", "E"],
  87: ["A", "B", "C", "D", "E"],
  88: ["A", "B", "C", "D", "E"],
  89: ["A", "B", "C", "D", "E"],
  90: ["A", "B", "C", "D", "E"],
  91: ["A", "B", "C", "D", "E"],
  92: ["A", "B", "C", "D", "E"],
  93: ["A", "B", "C", "D", "E"],
  94: ["A", "B", "C", "D", "E"],
  95: ["A", "B", "C", "D", "E"],
  96: ["A", "B", "C", "D", "E"],
  97: ["A", "B", "C", "D", "E"],
  98: ["A", "B", "C", "D", "E"],
  99: ["A", "B", "C", "D", "E"],
  100: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  101: ["A", "B", "C", "D", "E"],
  102: ["A", "B", "C", "D", "E"],
  103: ["A", "B", "C", "D", "E"],
  104: ["A", "B", "C", "D", "E"],
  105: ["A", "B", "C", "D", "E"],
  106: ["A", "B", "C", "D", "E"],
  107: ["A", "B", "C", "D", "E"],
  108: ["A", "B", "C", "D", "E"],
  109: ["A", "B", "C", "D", "E"],
  110: ["A", "B", "C", "D", "E"],
  111: ["A", "B", "C", "D", "E"],
  112: ["A", "B", "C", "D", "E"],
  113: ["A", "B", "C", "D", "E"],
  114: ["A", "B", "C", "D", "E"],
  115: ["A", "B", "C", "D", "E"],
  116: ["A", "B", "C", "D", "E"],
  117: ["A", "B", "C", "D", "E"],
  118: ["A", "B", "C", "D", "E"],
  119: ["A", "B", "C", "D", "E"],
  120: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  121: ["A", "B", "C", "D", "E"],
  122: ["A", "B", "C", "D", "E"],
  123: ["A", "B", "C", "D", "E"],
  124: ["A", "B", "C", "D", "E"],
  125: ["A", "B", "C", "D", "E"],
  126: ["A", "B", "C", "D", "E"],
  127: ["A", "B", "C", "D", "E"],
  128: ["A", "B", "C", "D", "E"],
  129: ["A", "B", "C", "D", "E"],
  130: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  131: ["A", "B", "C", "D", "E", "F"],
  132: ["A", "B", "C", "D", "E"],
  133: ["A", "B", "C", "D", "E"],
  134: ["A", "B", "C"],
  135: ["A", "B", "C", "D", "E"],
  136: ["A", "B", "C", "D", "E"],
  137: ["A", "B", "C", "D", "E"],
  138: ["A", "B", "C", "D", "E"],
  139: ["A", "B", "C", "D", "E"],
  140: ["A", "B", "C", "D", "E", "F"],
  141: ["A", "B", "C", "D", "E"],
  142: ["A", "B", "C", "D", "E"],
  143: ["A", "B", "C", "D", "E"],
  144: ["A", "B", "C", "D", "E"],
  145: ["A", "B", "C", "D", "E"],
  146: ["A", "B", "C", "D", "E"],
  147: ["A", "B"],
  148: ["A", "B", "C", "D", "E"],
  149: ["A", "B", "C", "D", "E"],
  150: ["A", "B", "C", "D", "E"],
  151: ["A", "B", "C", "D", "E"],
  152: ["A", "B", "C", "D", "E"],
  153: ["A", "B", "C", "D", "E"],
  154: ["A", "B", "C", "D", "E"],
  155: ["A", "B", "C", "D", "E"],
  156: ["A", "B", "C", "D", "E"],
  157: ["A", "B", "C", "D", "E"],
  158: ["A", "B", "C", "D", "E"],
  159: ["A", "B", "C", "D", "E"],
  160: ["A", "B", "C", "D", "E"],
  161: ["A", "B", "C", "D", "E"],
  162: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  163: ["A", "B", "C", "D", "E"],
  164: ["A", "B", "C", "D", "E"],
  165: ["A", "B", "C", "D", "E"],
  166: ["A", "B", "C", "D", "E"],
  167: ["A", "B", "C", "D", "E"],
  168: ["A", "B", "C", "D", "E"],
  169: ["A", "B", "C", "D", "E"],
  170: ["A"],
  171: ["A", "B", "C", "D", "E", "F", "G", "H"],
  172: ["A", "B", "C", "D", "E"],
  173: ["A", "B", "C", "D", "E"],
  174: ["A", "B", "C", "D", "E"],
  175: ["A", "B", "C", "D", "E", "F"],
  176: ["A", "B", "C", "D", "E"],
  177: [
    "A1",
    "A2",
    "B1",
    "B2",
    "C1",
    "C2",
    "D1",
    "D2",
    "E1",
    "E2",
    "F1",
    "F2",
    "G1",
    "G2",
  ],
  178: [
    "A1",
    "A2",
    "A3",
    "B1",
    "B2",
    "B3",
    "C1",
    "C2",
    "C3",
    "D1",
    "D2",
    "D3",
    "E1",
    "E2",
    "E3",
    "F1",
    "F2",
    "F3",
  ],
  179: [],
  180: ["A", "B", "C", "D", "E", "F"],
  181: ["A", "B", "C", "D", "E"],
  182: ["A", "B", "C", "D", "E"],
  183: ["A", "B", "C", "D", "E"],
  184: [],
  185: ["A", "B", "C", "D", "E"],
  186: ["A", "B", "C", "D", "E"],
  187: ["A", "B", "C", "D", "E"],
  188: ["A", "B", "C", "D", "E", "F", "G", "H"],
  189: ["A", "B", "C", "D", "E"],
  190: ["A", "B", "C", "D", "E"],
  191: ["A", "B", "C", "D", "E"],
  192: ["A", "B", "C", "D", "E"],
  193: ["A", "B", "C", "D", "E"],
  194: ["A", "B", "C", "D", "E"],
  195: ["A", "B", "C", "D", "E"],
  196: ["A", "B", "C", "D", "E"],
  197: ["A", "B", "C", "D", "E"],
  198: ["A", "B", "C", "D", "E"],
  199: ["A", "B", "C", "D", "E"],
  200: ["A", "B", "C", "D", "E"],
  201: ["A", "B", "C", "D", "E"],
  202: ["A", "B", "C", "D", "E"],
  203: ["A", "B", "C", "D", "E"],
  204: ["A", "B", "C", "D", "E"],
  205: ["A", "B", "C", "D", "E"],
  206: [
    "A1",
    "A2",
    "A3",
    "B1",
    "B2",
    "B3",
    "C1",
    "C2",
    "C3",
    "D1",
    "D10",
    "D2",
    "D3",
    "D4",
    "D5",
    "D6",
    "D7",
    "D8",
    "D9",
  ],
  207: [
    "A1",
    "A2",
    "A3",
    "B1",
    "B2",
    "B3",
    "C1",
    "C2",
    "C3",
    "D1",
    "D10",
    "D2",
    "D3",
    "D4",
    "D5",
    "D6",
    "D7",
    "D8",
    "D9",
  ],
  208: ["A", "B", "C", "D", "E"],
  209: ["A", "B", "C"],
  210: [],
  211: ["A", "B", "C", "D", "E"],
  212: ["A", "B", "C", "D", "E"],
  213: ["A", "B", "C", "D", "E"],
  214: ["A", "B", "C", "D", "E"],
  215: ["A", "B", "C", "D", "E"],
  216: ["A", "B", "C", "D", "E"],
  217: ["A", "B", "C", "D", "E"],
  218: ["A", "B", "C", "D", "E"],
  219: ["A", "B", "C", "D", "E"],
  220: ["A", "B", "C", "D", "E"],
  221: ["A", "B", "C", "D", "E"],
  222: ["A", "B", "C", "D", "E"],
  223: ["A", "B", "C", "D", "E"],
  224: ["A", "B", "C", "D", "E"],
  225: ["A", "B", "C", "D", "E"],
  226: ["A", "B", "C", "D", "E"],
  227: ["A", "B", "C", "D", "E"],
  228: ["A", "B", "C", "D", "E"],
  229: ["A", "B", "C", "D", "E"],
  230: ["A", "B", "C", "D", "E"],
  231: ["A", "B", "C", "D", "E"],
  232: ["A", "B", "C", "D", "E"],
  233: ["A", "B", "C", "D", "E"],
  234: ["A", "B", "C", "D", "E", "F", "G", "H"],
  235: ["A", "B", "C", "D", "E"],
  236: ["A", "B", "C", "D", "E"],
  237: ["A", "B", "C", "D", "E"],
  238: ["A", "B", "C", "D", "E"],
  239: ["A", "B", "C", "D", "E"],
  240: ["A", "B", "C", "D", "E", "F"],
  241: ["A", "B", "C", "D", "E", "F", "G"],
  242: ["A", "B", "C", "D", "E"],
  243: ["A", "B", "C", "D", "E"],
  244: ["A", "B", "C", "D", "E"],
  245: ["A", "B", "C", "D", "E", "F", "G", "H"],
  246: ["A", "B", "C", "D", "E"],
  247: ["A", "B", "C", "D", "E"],
  248: ["A", "B", "C", "D", "E"],
  249: ["A", "B", "C", "D", "E"],
  250: ["A", "B", "C", "D", "E"],
  251: ["A", "B", "C", "D", "E"],
  252: ["A", "B", "C", "D", "E"],
  253: ["A", "B", "C", "D", "E"],
  254: ["A", "B", "C", "D", "E"],
  255: ["A", "B", "C", "D", "E"],
  256: ["A", "B", "C", "D", "E"],
  257: ["A", "B", "C", "D", "E"],
  258: ["A", "B", "C", "D", "E"],
  259: ["A", "B", "C", "D", "E"],
  260: ["A", "B", "C", "D", "E"],
  261: ["A", "B", "C", "D", "E"],
  262: ["A", "B", "C", "D", "E"],
  263: ["A", "B", "C", "D", "E"],
  264: ["A", "B", "C", "D", "E"],
  265: ["A", "B", "C", "D", "E"],
  266: ["A", "B", "C", "D", "E"],
  267: ["A", "B", "C"],
  268: ["A", "B", "C", "D", "E"],
  269: ["A", "B", "C", "D", "E"],
  270: ["A", "B", "C", "D", "E"],
  271: ["A", "B", "C", "D", "E"],
  272: ["A", "B", "C", "D", "E"],
  273: ["A", "B", "C", "D", "E"],
  274: ["A", "B", "C", "D", "E"],
  275: ["A", "B", "C", "D", "E"],
  276: ["A", "B", "C", "D", "E"],
  277: ["A", "B", "C", "D", "E"],
  278: ["A", "B", "C", "D", "E"],
  279: ["A", "B", "C", "D", "E"],
  280: ["A", "B", "C", "D", "E"],
  281: ["A", "B", "C", "D", "E"],
  282: ["A", "B", "C", "D", "E"],
  283: ["A", "B", "C", "D", "E"],
  284: ["A", "B", "C", "D", "E"],
  285: ["A", "B", "C", "D", "E"],
  286: ["A", "B", "C", "D", "E"],
  287: ["A", "B", "C", "D", "E"],
  288: ["A", "B", "C", "D", "E"],
  289: ["A", "B", "C", "D", "E"],
  290: ["A", "B", "C", "D", "E", "F"],
  291: ["A", "B", "C", "D", "E"],
  292: ["A", "B", "C", "D", "E"],
  293: ["A", "B", "C", "D", "E"],
  294: ["A", "B", "C", "D", "E"],
  295: ["A", "B", "C", "D", "E"],
  296: ["A", "B", "C", "D", "E"],
  297: ["A", "B", "C", "D", "E"],
  298: ["A", "B", "C", "D", "E"],
  299: ["A", "B", "C", "D", "E"],
  300: ["A", "B", "C", "D", "E"],
  301: ["A", "B", "C", "D", "E"],
  302: ["A", "B", "C", "D", "E"],
  303: ["A", "B", "C", "D", "E"],
  304: ["A", "B", "C", "D", "E"],
  305: ["A", "B", "C", "D", "E"],
  306: ["A", "B", "C", "D"],
  307: [],
  308: ["A", "B", "C", "D", "E"],
  309: ["A", "B", "C", "D", "E"],
  310: [],
  311: ["A", "B", "C", "D", "E"],
  312: ["A", "B", "C", "D", "E"],
  313: ["A", "B", "C", "D", "E"],
  314: ["A", "B", "C", "D", "E"],
  315: ["A", "B", "C", "D", "E"],
  316: [
    "A1",
    "A2",
    "B1",
    "B2",
    "C1",
    "C2",
    "D1",
    "D2",
    "D3",
    "E1",
    "E2",
    "E3",
    "F1",
    "F2",
    "F3",
    "G1",
    "G2",
    "G3",
  ],
  317: ["A", "B", "C", "D", "E"],
  318: ["A", "B", "C", "D", "E"],
  319: ["A", "B", "C", "D", "E"],
  320: ["A", "B", "C", "D", "E"],
  321: ["A", "B", "C", "D", "E"],
  322: ["A", "B", "C", "D", "E"],
  323: ["A", "B", "C"],
  324: ["A1", "A2", "B1", "B2", "C1", "C2", "C3", "D1", "D2", "D3", "E1", "E2"],
  325: ["A", "B", "C", "D", "E"],
  326: ["A", "B", "C", "D", "E", "F"],
  327: ["A", "B", "C", "D", "E"],
  328: ["A", "B"],
  329: ["A", "B", "C", "D", "E"],
  330: ["A", "B", "C", "D", "E"],
  331: ["A1", "A2", "B1", "B2", "C1", "C2", "C3", "D1", "D2", "D3", "E1", "E2"],
  332: ["A", "B", "C", "D", "E"],
  333: ["A", "B", "C", "D", "E"],
  334: ["A", "B", "C", "D", "E"],
  335: ["A", "B", "C", "D", "E", "F"],
  336: ["A", "B", "C", "D", "E"],
  337: ["A", "B", "C", "D", "E"],
  338: ["A", "B", "C", "D", "E"],
  339: ["A", "B", "C", "D", "E"],
  340: ["A", "B", "C", "D", "E"],
  341: ["A", "B", "C", "D", "E"],
  342: ["A", "B", "C", "D", "E"],
  343: ["A", "B", "C", "D", "E"],
  344: ["A", "B", "C", "D", "E"],
  345: ["A", "B", "C", "D", "E", "F", "G"],
  346: ["A", "B", "C", "D", "E"],
  347: ["A", "B", "C", "D", "E"],
  348: ["A", "B", "C", "D", "E"],
  349: ["A", "B", "C", "D", "E"],
  350: ["A", "B", "C", "D", "E"],
  351: ["A", "B", "C", "D", "E"],
  352: ["A", "B", "C", "D", "E"],
  353: ["A", "B", "C", "D", "E"],
  354: ["A", "B", "C", "D", "E"],
  355: ["A", "B", "C", "D", "E"],
  356: ["A", "B", "C", "D", "E"],
  357: ["A", "B", "C", "D", "E"],
  358: ["A", "B", "C", "D", "E"],
  359: ["A", "B", "C", "D", "E"],
  360: ["A", "B", "C", "D", "E"],
  361: ["A", "B", "C", "D", "E"],
  362: ["A", "B", "C", "D", "E"],
  363: ["A", "B", "C", "D", "E"],
  364: ["A", "B", "C", "D", "E"],
  365: ["A", "B", "C", "D", "E"],
  366: ["A", "B", "C", "D", "E"],
  367: ["A", "B", "C", "D", "E"],
  368: ["A", "B", "C", "D", "E"],
  369: ["A", "B", "C", "D", "E"],
  370: ["A", "B", "C", "D", "E"],
  371: ["A", "B", "C", "D", "E"],
  372: ["A", "B", "C", "D", "E"],
  373: ["A", "B", "C", "D", "E"],
  374: ["A", "B", "C", "D", "E"],
  375: ["A", "B", "C", "D", "E"],
  376: ["A", "B", "C", "D", "E"],
  377: ["A", "B", "C", "D", "E"],
  378: ["A", "B", "C", "D", "E"],
  379: ["A", "B", "C", "D", "E", "F", "G"],
  380: ["A", "B", "C", "D", "E"],
  381: ["A", "B", "C", "D", "E"],
  382: ["A", "B", "C", "D", "E"],
  383: ["A", "B", "C", "D", "E"],
  384: ["A", "B", "C", "D", "E"],
  385: ["A", "B", "C", "D", "E"],
  386: ["A", "B", "C", "D"],
  387: ["A", "B", "C", "D", "E"],
  388: ["A", "B", "C", "D", "E"],
  389: ["A", "B", "C", "D", "E"],
  390: ["A", "B", "C", "D", "E"],
  391: ["A", "B", "C1", "C2", "C3", "D1", "D2", "E1", "E2", "F1", "F2", "F3"],
  392: ["A", "B", "C", "D", "E"],
  393: ["A", "B", "C", "D", "E"],
  394: ["A", "B", "C", "D", "E"],
  395: [],
  396: ["A", "B", "C", "D", "E"],
  397: ["A", "B", "C", "D", "E"],
  398: ["A", "B", "C", "D", "E"],
  399: ["A", "B", "C", "D", "E"],
  400: ["A", "B", "C", "D", "E"],
  401: ["A", "B", "C", "D", "E"],
  402: ["A", "B", "C", "D", "E"],
  403: ["A", "B", "C", "D", "E"],
  404: ["A", "B", "C", "D", "E"],
  405: ["A", "B", "C", "D", "E"],
  406: ["A", "B", "C", "D", "E"],
  407: ["A", "B", "C", "D", "E"],
  408: ["A", "B", "C", "D", "E"],
  409: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  410: [],
  411: ["A", "B", "C"],
  412: ["A", "B", "C", "D", "E"],
  413: ["A", "B", "C", "D", "E"],
  414: ["A", "B", "C", "D", "E"],
  415: ["A", "B", "C", "D", "E"],
  416: ["A", "B", "C", "D", "E"],
  417: ["A", "B", "C", "D", "E"],
  418: ["A", "B", "C", "D", "E"],
  419: ["A", "B", "C", "D", "E"],
  420: ["A", "B", "C", "D", "E"],
  421: ["A", "B", "C", "D", "E"],
  422: [],
  423: [],
  424: ["A", "B", "C", "D", "E"],
  425: ["A", "B", "C", "D", "E"],
  426: ["A", "B", "C", "D", "E"],
  427: ["A", "B", "C", "D", "E"],
  428: [],
  429: ["A", "B", "C", "D", "E"],
  430: ["A", "B", "C", "D", "E"],
  431: ["A", "B", "C", "D", "E"],
  432: ["A", "B", "C", "D", "E"],
  433: ["A", "B", "C", "D", "E"],
  434: ["A", "B", "C", "D", "E"],
  435: ["A", "B", "C", "D", "E"],
  436: ["A", "B", "C", "D", "E", "F"],
  437: ["A", "B", "C", "D", "E"],
  438: ["A", "B", "C", "D", "E"],
  439: ["A", "B", "C", "D", "E"],
  440: ["A", "B", "C", "D"],
  441: ["A", "B", "C", "D", "E"],
  442: ["A", "B", "C", "D", "E"],
  443: ["A", "B", "C", "D", "E"],
  444: ["A", "B", "C", "D", "E"],
  445: ["A", "B", "C", "D", "E"],
  446: ["A", "B", "C", "D", "E"],
  447: ["A", "B", "C", "D", "E"],
  448: ["A", "B", "C", "D", "E"],
  449: ["A", "B", "C", "D", "E"],
  450: ["A", "B", "C", "D", "E"],
  451: ["A", "B", "C", "D", "E"],
  452: ["A", "B", "C", "D", "E", "F"],
  453: ["A", "B", "C", "D", "E"],
  454: ["A", "B", "C", "D", "E"],
  455: ["A", "B", "C", "D", "E"],
  456: ["A", "B", "C", "D", "E"],
  457: ["A", "B", "C", "D", "E", "F"],
  458: ["A", "B", "C", "D", "E", "F"],
  459: ["A", "B", "C", "D", "E"],
  460: ["A", "B", "C", "D", "E"],
  461: ["A", "B", "C", "D", "E"],
  462: ["A", "B", "C", "D", "E"],
  463: ["A", "B", "C", "D", "E"],
  464: ["A", "B", "C", "D", "E"],
  465: ["A", "B", "C", "D", "E"],
  466: ["A", "B", "C", "D", "E"],
  467: ["A", "B", "C", "D", "E"],
  468: ["A", "B", "C", "D", "E"],
  469: ["A", "B", "C", "D", "E"],
  470: ["A", "B", "C", "D", "E", "F", "G", "H"],
  471: ["A", "B", "C", "D", "E"],
  472: ["A", "B", "C", "D", "E", "F", "G"],
  473: [],
  474: ["A", "B", "C", "D", "E", "F"],
  475: ["A", "B", "C", "D", "E", "F"],
  476: ["A", "B", "C", "D", "E"],
  477: ["A", "B", "C", "D", "E"],
  478: ["A", "B", "C", "D", "E"],
  479: ["A", "B", "C", "D", "E"],
  480: ["A", "B", "C", "D", "E"],
  481: [],
  482: ["A", "B", "C", "D", "E"],
  483: ["A", "B", "C", "D", "E"],
  484: ["A", "B", "C", "D", "E"],
  485: ["A", "B", "C", "D", "E"],
  486: ["A", "B", "C", "D", "E"],
  487: ["A", "B", "C", "D", "E"],
  488: ["A", "B", "C", "D", "E"],
  489: ["A", "B", "C", "D", "E", "F"],
  490: ["A", "B", "C", "D", "E", "F"],
  491: ["A", "B", "C"],
  492: ["A", "B", "C", "D", "E"],
  493: ["A", "B", "C", "D", "E"],
  494: ["A", "B", "C", "D", "E"],
  495: ["A", "B", "C", "D", "E"],
  496: ["A", "B", "C", "D", "E"],
  497: ["A", "B", "C", "D", "E"],
  498: ["A", "B", "C", "D", "E"],
  499: ["A", "B", "C", "D", "E"],
  500: ["A", "B", "C", "D", "E", "F", "G"],
  501: ["A", "B", "C", "D", "E"],
  502: [],
  503: [],
  504: ["A", "B", "C", "D", "E"],
  505: ["A", "B", "C", "D", "E"],
  506: ["A", "B", "C", "D", "E"],
  507: ["A", "B", "C", "D", "E"],
  508: ["A", "B", "C", "D", "E"],
  509: ["A", "B", "C", "D", "E", "F"],
  510: ["A", "B", "C", "D", "E"],
  511: [],
  512: ["A", "B", "C", "D", "E"],
  513: [
    "A",
    "B1",
    "B2",
    "C",
    "D1",
    "D2",
    "E1",
    "E2",
    "F1",
    "F2",
    "G1",
    "G2",
    "G3",
  ],
  514: ["A", "B", "C", "D", "E"],
  515: ["A", "B", "C", "D", "E"],
  516: ["A", "B", "C", "D", "E"],
  517: [],
  518: ["A", "B", "C", "D", "E", "F"],
  519: ["A", "B", "C", "D", "E"],
  520: ["A", "B", "C", "D", "E"],
  521: ["A", "B", "C", "D", "E"],
  522: ["A", "B", "C", "D"],
  523: ["A", "B", "C", "D"],
  524: ["A", "B", "C", "D", "E", "F"],
  525: ["A", "B", "C", "D", "E"],
  526: ["A", "B", "C", "D", "E", "F", "G"],
  527: ["A", "B", "C", "D", "E"],
  528: ["A", "B", "C", "D", "E"],
  529: ["A", "B", "C", "D", "E"],
  530: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  531: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  532: ["A", "B", "C", "D", "E", "F"],
  533: ["A", "B", "C", "D", "E", "F"],
  534: ["A", "B", "C", "D", "E", "F"],
  535: ["A", "B", "C", "D", "E"],
  536: ["A", "B", "C", "D", "E"],
  537: ["A"],
  538: ["A", "B", "C", "D", "E", "F", "G", "H"],
  539: [],
  540: ["A", "B", "C", "D", "E"],
  541: ["A", "B", "C", "D", "E", "F"],
  542: ["A", "B", "C", "D", "E", "F"],
  543: ["A", "B", "C", "D", "E"],
  544: ["A", "B", "C", "D", "E"],
  545: ["A", "B", "C", "D", "E"],
  546: ["A", "B", "C", "D", "E"],
  547: ["A", "B", "C", "D", "E"],
  548: ["A", "B", "C", "D", "E"],
  549: ["A", "B", "C", "D", "E", "F", "G", "H"],
  550: ["A", "B", "C", "D", "E"],
  551: ["A", "B", "C", "D", "E"],
  552: ["A", "B", "C", "D", "E"],
  553: ["A", "B", "C", "D", "E"],
  554: ["A", "B", "C", "D", "E"],
  555: ["A", "B", "C", "D", "E"],
  556: ["A", "B", "C", "D", "E"],
  557: ["A", "B", "C", "D", "E"],
  558: ["A", "B", "C", "D", "E"],
  559: ["A", "B", "C", "D", "E"],
  560: ["A", "B", "C", "D", "E"],
  561: [],
  562: ["A", "B", "C", "D", "E", "F", "G"],
  563: [],
  564: [],
  565: [],
  566: ["A", "B", "C", "D", "E", "F", "G"],
  567: ["A", "B", "C", "D", "E", "F"],
  568: ["A", "B", "C", "D", "E"],
  569: ["A", "B", "C", "D", "E"],
  570: ["A", "B", "C", "D", "E"],
  571: ["A", "B", "C", "D", "E"],
  572: ["A", "B", "C", "D", "E"],
  573: ["A", "B", "C", "D", "E"],
  574: ["A", "B", "C", "D", "E"],
  575: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  576: ["A", "B", "C", "D", "E"],
  577: ["A", "B", "C", "D", "E"],
  578: ["A", "B", "C", "D", "E", "F"],
  579: ["A", "B", "C", "D", "E", "F"],
  580: ["A", "B", "C", "D", "E"],
  581: ["A", "B", "C", "D", "E", "F"],
  582: ["A", "B", "C", "D", "E"],
  583: ["A", "B", "C", "D", "E"],
  584: ["A", "B", "C", "D", "E"],
  585: ["A", "B", "C", "D", "E", "F"],
  586: ["A", "B", "C", "D", "E", "F"],
  587: ["A", "B", "C", "D", "E", "F"],
  588: ["A", "B", "C", "D", "E", "F"],
  589: [],
  590: ["A", "B", "C", "D", "E"],
  591: ["A", "B", "C", "D", "E"],
  592: ["A", "B", "C", "D", "E"],
  593: ["A", "B", "C", "D", "E"],
  594: ["A", "B", "C", "D", "E"],
  595: ["A", "B", "C", "D", "E"],
  596: ["A", "B", "C", "D", "E"],
  597: ["A", "B", "C"],
  598: ["A", "B", "C", "D", "E", "F"],
  599: ["A", "B", "C", "D", "E"],
  600: ["A", "B", "C", "D", "E", "F"],
  601: ["A", "B", "C", "D", "E"],
  602: ["A", "B", "C", "D", "E"],
  603: ["A", "B", "C", "D", "E"],
  604: ["A", "B", "C", "D", "E"],
  605: ["A", "B", "C", "D", "E"],
  606: ["A", "B", "C", "D", "E"],
  607: ["A", "B", "C", "D", "E"],
  608: ["A", "B", "C", "D", "E"],
  609: ["A", "B", "C", "D", "E", "F"],
  610: ["A", "B", "C", "D", "E"],
  611: ["A", "B", "C", "D", "E", "F", "G", "H"],
  612: ["A", "B", "C", "D", "E", "F"],
  613: ["A", "B", "C", "D", "E"],
  614: ["A", "B", "C", "D", "E"],
  615: ["A", "B", "C", "D", "E"],
  616: ["A", "B", "C", "D", "E", "F"],
  617: ["A", "B", "C", "D", "E"],
  618: ["A", "B", "C", "D", "E", "F", "G"],
  619: [],
  620: ["A", "B", "C", "D", "E", "F"],
  621: ["A", "B", "C", "D", "E"],
  622: ["A", "B", "C", "D", "E", "F"],
  623: ["A", "B", "C", "D", "E"],
  624: ["A", "B", "C", "D", "E"],
  625: ["A", "B", "C", "D", "E"],
  626: ["A", "B", "C", "D", "E", "F", "G"],
  627: ["A", "B", "C", "D", "E", "F"],
  628: ["A", "B", "C", "D", "E", "F"],
  629: ["A", "B", "C", "D", "E"],
  630: [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
  ],
  631: ["A", "B", "C", "D", "E"],
  632: ["A", "B", "C", "D", "E", "F"],
  633: ["A", "B", "C", "D", "E", "F", "G", "H"],
  634: ["A", "B", "C", "D", "E", "F"],
  635: ["A", "B", "C", "D", "E", "F"],
  636: ["A"],
  637: ["A", "B", "C", "D"],
  638: ["A", "B", "C", "D"],
  639: ["A", "B", "C", "D", "E", "F"],
  640: ["A", "B", "C", "D", "E", "F", "G", "H"],
  641: ["A", "B", "C", "D", "E", "F", "G"],
  642: ["A"],
  643: ["A", "B", "C", "D", "E", "F", "G"],
  644: ["A", "B", "C"],
  645: ["A", "B", "C", "D", "E", "F", "G"],
  646: ["A", "B"],
  647: ["A", "B"],
  648: ["A", "B", "C", "D", "E"],
  649: ["A", "B", "C", "D", "E"],
  650: ["A", "B", "C", "D", "E"],
  651: ["A", "B", "C", "D", "E"],
  652: ["A", "B", "C", "D", "E", "F"],
  653: ["A", "B", "C", "D", "E", "F", "G"],
  654: [],
  655: ["A", "B", "C", "D", "E", "F", "G"],
  656: ["A", "B", "C", "D", "E", "F", "G"],
  657: ["A", "B", "C", "D", "E"],
  658: ["A", "B", "C", "D", "E"],
  659: ["A", "B", "C", "D", "E", "F", "G"],
  660: ["A", "B", "C", "D", "E", "F"],
  661: ["A", "B", "C", "D", "E", "F", "G", "H"],
  662: ["A", "B", "C", "D", "E"],
  663: ["A", "B", "C", "D", "E"],
  664: ["A", "B", "C", "D", "E"],
  665: ["A", "B", "C", "D", "E", "F"],
  666: ["A", "B", "C", "D", "E"],
  667: ["A", "B", "C", "D", "E"],
  668: ["A", "B", "C", "D", "E", "F"],
  669: ["A", "B", "C", "D", "E"],
  670: ["A", "B", "C", "D1", "D2", "E", "F"],
  671: ["A", "B", "C", "D", "E"],
  672: ["A", "B", "C", "D", "E"],
  673: ["A", "B", "C", "D", "E", "F"],
  674: ["A", "B", "C", "D", "E", "F", "G"],
  675: ["A", "B", "C", "D", "E"],
  676: ["A", "B", "C", "D", "E"],
  677: ["A", "B", "C", "D", "E"],
  678: ["A", "B", "C", "D", "E", "F"],
  679: ["A", "B", "C", "D", "E"],
  680: ["A", "B", "C", "D", "E"],
  681: ["A", "B", "C", "D", "E"],
  682: ["A", "B", "C", "D", "E"],
  683: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  684: ["A2"],
  685: ["A", "B", "C", "D", "E"],
  686: ["A", "B", "C", "D", "E"],
  687: ["A", "B", "C", "D", "E"],
  688: ["A", "B", "C", "D", "E"],
  689: ["A", "B", "C", "D", "E"],
  690: [
    "A1",
    "A2",
    "A3",
    "B1",
    "B2",
    "B3",
    "C1",
    "C2",
    "C3",
    "D1",
    "D2",
    "D3",
    "E1",
    "E2",
    "F1",
    "F2",
    "F3",
  ],
  691: ["A", "B", "C", "D", "E", "F"],
  692: [],
  693: [],
  694: [],
  695: ["A", "B", "C", "D", "E", "F", "G"],
  696: ["A", "B", "C", "D", "E", "F"],
  697: ["A", "B", "C", "D", "E", "F"],
  698: ["A", "B", "C", "D", "E", "F"],
  699: ["A", "B", "C", "D", "E", "F"],
  700: ["A", "B", "C", "D", "E"],
  701: ["A", "B", "C", "D", "E", "F"],
  702: ["A", "B", "C", "D", "E", "F"],
  703: ["A", "B", "C", "D", "E"],
  704: ["A", "B", "C", "D", "E"],
  705: ["A", "B", "C", "D", "E"],
  706: ["A", "B", "C", "D", "E"],
  707: ["A", "B", "C", "D", "E"],
  708: ["A", "B", "C", "D", "E"],
  709: ["A", "B", "C", "D", "E"],
  710: ["A", "B", "C", "D", "E", "F"],
  711: ["A", "B", "C", "D", "E"],
  712: ["A", "B", "C", "D", "E"],
  713: ["A", "B", "C", "D", "E"],
  714: ["A", "B", "C", "D", "E"],
  715: ["A", "B", "C", "D", "E"],
  716: ["A", "B", "C", "D", "E"],
  717: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  718: ["A", "C", "D", "E"],
  719: ["A", "B", "C", "E"],
  720: ["A", "B", "C", "D", "E", "F"],
  721: ["A", "B", "C", "D", "E"],
  722: ["A", "B", "C", "D", "E", "F"],
  723: ["A", "B", "C", "D", "E", "F"],
  724: ["A", "B", "C", "D", "E", "F", "G"],
  725: ["A", "B", "C", "D", "E", "F", "G"],
  726: [],
  727: ["A", "B", "C", "D", "E", "F"],
  728: [],
  729: ["A", "B", "C", "D", "E", "F"],
  730: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
  731: ["A", "B", "C", "D", "E", "F"],
  732: ["A", "B", "C", "D", "E", "F"],
  733: ["A", "B", "C", "D", "E", "F"],
  734: ["A", "B", "C", "D", "E", "F"],
  735: ["A", "B", "C", "D", "E"],
  736: ["A", "B", "C", "D", "E"],
  737: ["A", "B", "C", "D", "E", "F"],
  738: ["A", "B", "C", "D", "E", "F"],
  739: ["A", "B", "C", "D", "E"],
  740: ["A", "B", "C", "D", "E"],
  741: ["A", "B", "C", "D", "E"],
  742: ["A", "B", "C", "D", "E"],
  743: ["A", "B", "C", "D", "E"],
  744: ["A", "B", "C", "D", "E"],
  745: ["A", "B", "C", "D", "E"],
  746: ["A", "B", "C", "D", "E", "F", "G"],
  747: ["A", "B", "C", "D", "E", "F"],
  748: ["A", "B", "C", "D", "E", "F"],
  749: ["A", "B", "C", "D", "E"],
  750: ["A", "B", "C", "D", "E", "F", "G", "H"],
  751: ["A", "B"],
  752: ["A", "B", "C", "D", "E", "F"],
  753: ["A", "B", "C"],
  754: ["A", "B", "C", "D", "E"],
  755: ["A", "B", "C", "D", "E", "F", "G"],
  756: ["A", "B", "C", "D", "E", "F"],
  757: ["A", "B", "C", "D", "E", "F", "G"],
  758: ["A", "B", "C", "D", "E", "F"],
  759: ["A", "B", "C", "D", "E", "F"],
  760: ["A", "B", "C", "D", "E", "F"],
  761: ["A", "B", "C", "D", "E", "F"],
  762: ["A", "B", "C", "D", "E", "F"],
  763: ["A", "B", "C", "D", "E"],
  764: ["A", "B", "C", "D", "E"],
  765: ["A", "B", "C", "D", "E", "F", "G"],
  766: ["A", "B", "C", "D", "E"],
  767: ["A", "B", "C", "D", "E"],
  768: ["A", "B", "C", "D", "E", "F", "G"],
  769: ["A", "B", "C", "D"],
  770: ["A", "B", "C", "D"],
  771: ["A", "B", "C", "D", "E", "F"],
  772: ["A", "B", "C", "D", "E"],
  773: ["A", "B", "C", "D", "E", "F"],
  774: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
  775: ["A"],
  776: ["A", "B", "C", "D", "E", "F", "G"],
  777: ["A", "B", "C", "D", "E"],
  778: ["A", "B", "C", "D", "E"],
  779: ["A", "B", "C", "D", "E", "F"],
  780: ["A", "B", "C", "D", "E", "F", "G", "H"],
  781: ["A", "B", "C", "D", "E", "F"],
  782: ["A", "B", "C", "D", "E", "F"],
  783: [],
  784: ["A", "B", "C", "D", "E", "F", "G"],
  785: ["A", "B", "C", "D", "E"],
  786: ["A", "B", "C", "D", "E"],
  787: ["A", "B", "C", "D", "E"],
  788: ["A", "B", "C", "D", "E"],
  789: ["A", "B", "C", "D", "E"],
  790: ["A", "B", "C", "D", "E"],
  791: ["A", "B", "C", "D", "E"],
  792: ["A", "B", "C", "D", "E", "F"],
  793: ["A", "B", "C", "D", "E", "F", "G"],
  794: ["A", "B", "C", "D", "E", "F", "G"],
  795: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
  796: ["A", "B", "C", "D", "E", "F"],
  797: ["A", "B", "C", "D", "E", "F"],
  798: ["A", "B", "C", "D", "E"],
  799: ["A", "B", "C", "D", "E", "F", "G"],
  800: ["A", "B", "C", "D", "E"],
  801: ["A", "B", "C", "D", "E"],
  802: [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
  ],
  803: ["A", "B", "C", "D", "E", "F", "G"],
  804: ["A", "B", "C", "D", "E", "F"],
  805: ["A", "B", "C", "D", "E", "F"],
  806: ["A", "B", "C", "D", "E", "F"],
  807: ["A", "B", "C", "D", "E", "F"],
  808: ["A", "B", "C", "D", "E", "F", "G"],
  809: ["A", "B", "C", "D", "E"],
  810: ["A", "B", "C", "D", "E"],
  811: ["A", "B", "C", "D", "E"],
  812: ["A", "B", "C", "D", "E"],
  813: ["A", "B", "C", "D", "E", "F"],
  814: ["A", "B", "C", "D", "E"],
  815: ["A", "B", "C", "D", "E"],
  816: ["A", "B", "C", "D", "E"],
  817: ["A", "B", "C", "D", "E", "F"],
  818: ["A", "B", "C", "D", "E", "F", "G"],
  819: ["A", "B", "C", "D", "E"],
  820: ["A", "B", "C", "D", "E"],
  821: ["A", "B", "C", "D", "E"],
  822: ["A", "B", "C", "D", "E", "F"],
  823: ["A", "B", "C", "D", "E", "F", "G"],
  824: [],
  825: ["A", "B", "C", "D", "E", "F", "G"],
  826: [],
  827: ["A", "B", "C", "D", "E", "F"],
  828: ["A", "B", "C", "D", "E", "F"],
  829: [],
  830: ["A", "B", "C", "D", "E"],
  831: ["A", "B", "C", "D", "E", "F"],
  832: ["A", "B", "C", "D", "E"],
  833: ["A", "B", "C", "D", "E"],
  834: ["A", "B", "C", "D", "E"],
  835: ["A", "B", "C", "D", "E", "F"],
  837: ["A", "B", "C", "D", "E", "F", "G"],
  838: ["A", "B", "C", "D", "E", "F"],
  839: ["A", "B", "C", "D", "E"],
  840: ["A", "B", "C", "D", "E"],
  841: ["A", "B", "C", "D", "E"],
  842: ["A", "B", "C", "D", "E"],
  843: ["A", "B", "C", "D", "E"],
  844: ["A", "B", "C", "D", "E"],
  845: ["A", "B", "C", "D", "E", "F", "G"],
  846: ["A", "B", "C", "D", "E", "F"],
  847: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  848: ["A", "B", "C", "D", "E"],
  849: ["A", "B", "C", "D", "E"],
  850: ["A", "B", "C", "D", "E", "F"],
  851: ["A", "B", "C", "D", "E"],
  852: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  853: ["A", "B", "C", "D", "E"],
  854: ["A", "B", "C", "D", "E"],
  855: ["A", "B", "C", "D", "E", "F", "G"],
  856: ["A", "B", "C", "D", "E", "F"],
  857: [],
  858: ["A", "B", "C", "D", "E", "F"],
  859: ["A", "B", "C", "D", "E", "F", "G"],
  860: ["A", "B", "C", "D", "E"],
  861: ["A", "B", "C", "D", "E", "F"],
  862: ["A", "B", "C", "D", "E", "F"],
  863: ["A", "B", "C", "D", "E", "F", "G"],
  864: ["A", "B", "C", "D", "E", "F"],
  865: ["A", "B", "C", "D", "E", "F", "G"],
  866: ["A", "B", "C", "D", "E", "F", "G"],
  867: ["A", "B", "C", "D", "E", "F"],
  868: ["A", "B", "C", "D", "E", "F", "G"],
  869: ["A", "B", "C", "D", "E"],
  870: ["A", "B", "C", "D", "E", "F"],
  871: ["A", "B", "C", "D", "E"],
  872: ["A", "B", "C", "D", "E"],
  873: ["A", "B", "C", "D", "E", "F"],
  874: [],
  875: ["A", "B", "C", "D", "E", "F"],
  876: ["A", "B", "C", "D", "E", "F"],
  877: ["A", "B", "C", "D", "E", "F"],
  878: ["A", "B", "C", "D", "E"],
  879: ["A", "B", "C", "D", "E"],
  880: [],
  881: [],
  882: [],
  883: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  884: ["A", "B", "C", "D", "E", "F"],
  885: [],
  886: ["A", "B", "C", "D", "E", "F"],
  887: ["A", "B", "C", "D", "E", "F"],
  888: ["A", "B", "C", "D", "E", "F", "G"],
  889: ["A", "B", "C", "D", "E"],
  890: ["A", "B", "C", "D", "E", "F"],
  891: ["A", "B", "C", "D", "E"],
  892: ["A", "B", "C", "D", "E"],
  893: ["A", "B", "C", "D", "E", "F"],
  894: ["A", "B", "C", "D", "E"],
  895: ["A", "B", "C", "D", "E"],
  896: ["A", "B", "C", "D", "E"],
  897: ["A", "B", "C", "D", "E"],
  898: ["A", "B", "C", "D", "E", "F"],
  899: ["A", "B", "C", "D", "E", "F"],
  900: ["A", "B", "C", "D", "E"],
  901: ["A", "B", "C", "D", "E"],
  902: ["A", "B", "C", "D", "E"],
  903: ["A", "B", "C", "D", "E", "F", "G"],
  904: ["A", "B", "C", "D", "E", "F"],
  905: [],
  906: ["A", "B", "C", "D", "E"],
  907: ["A", "B", "C", "D", "E", "F"],
  908: ["A", "B", "C", "D", "E", "F", "G", "H"],
  909: ["A", "B", "C", "D", "E", "F"],
  910: ["A", "B", "C"],
  911: ["A", "B", "C", "D", "E", "F", "G"],
  912: ["A", "B", "C", "D", "E"],
  913: ["A", "B", "C", "D", "E", "F", "G", "H"],
  914: ["A", "B", "C", "D", "E", "F", "G", "H"],
  915: ["A", "B", "C", "D", "E", "F", "G"],
  916: ["A", "B", "C", "D", "E"],
  917: ["A", "B", "C", "D", "E"],
  918: ["A", "B", "C", "D", "E"],
  919: ["A", "B", "C", "D", "E", "F"],
  920: ["A", "B", "C", "D", "E", "F", "G"],
  921: [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
  ],
  922: ["A", "B", "C", "D", "E", "F"],
  923: ["A", "B", "C", "D", "E", "F"],
  924: ["A", "B", "C", "D", "E", "F"],
  925: ["A", "B", "C", "D", "E", "F"],
  926: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  927: ["A"],
  928: ["A", "B", "C", "D"],
  929: ["A", "B", "C", "D"],
  930: ["A", "B", "C", "D", "E"],
  931: ["A", "B", "C", "D", "E", "F"],
  932: ["A", "B", "C", "D", "E", "F", "G"],
  933: ["A", "B", "C", "D", "E"],
  934: ["A", "B", "C", "D", "E"],
  935: ["A", "B", "C", "D", "E", "F"],
  936: ["A", "B", "C", "D", "E"],
  937: ["A", "B", "C", "D", "E"],
  938: ["A", "B", "C", "D", "E", "F", "G"],
  939: ["A", "B", "C", "D", "E", "F"],
  940: ["A", "B", "C", "D", "E", "F"],
  941: [],
  942: [],
  943: [],
  944: ["A", "B", "C", "D", "E", "F", "G"],
  945: [],
  946: ["A", "B", "C", "D", "E", "F", "G"],
  947: ["A", "B", "C", "D", "E", "F"],
  948: ["A", "B", "C", "D", "E"],
  949: ["A", "B", "C", "D", "E", "F"],
  950: ["A", "B", "C", "D", "E", "F"],
  951: ["A", "B", "C", "D", "E", "F", "G"],
  952: ["A", "B", "C", "D", "E", "F", "G"],
  953: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  954: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  955: ["A", "B", "C", "D", "E", "F"],
  956: ["A", "B", "C", "D", "E", "F"],
  957: ["A", "B", "C", "D", "E"],
  958: [
    "A1",
    "A2",
    "A3",
    "B1",
    "B2",
    "C1",
    "C2",
    "C3",
    "D1",
    "D2",
    "E1",
    "E2",
    "E3",
    "F1",
    "F2",
    "F3",
  ],
  959: ["A", "B", "C", "D", "E", "F"],
  960: ["A", "B", "C", "D", "E", "F", "G", "H"],
  961: ["A", "B", "C", "D", "E", "F", "G"],
  962: ["A", "B", "C", "D", "E", "F", "G"],
  963: ["A", "B", "C", "D", "E"],
  964: ["A", "B", "C", "D", "E"],
  965: ["A", "B", "C", "D", "E"],
  966: ["A", "B", "C", "D", "E", "F"],
  967: ["A", "B", "C", "D", "E", "F"],
  968: [],
  969: [],
  970: [],
  971: [],
  972: [],
  973: [],
  974: [],
  975: ["A", "B", "C", "D", "E"],
  976: ["A", "B", "C", "D", "E", "F"],
  977: ["A", "B", "C", "D", "E", "F"],
  978: ["A", "B", "C", "D", "E", "F", "G"],
  979: ["A", "B", "C", "D", "E"],
  980: ["A", "B", "C", "D", "E", "F"],
  981: ["A", "B", "C", "D", "E", "F", "G", "H"],
  982: ["A", "B", "C", "D", "E", "F"],
  983: ["A", "B", "C", "D", "E"],
  984: ["A", "B", "C", "D", "E"],
  985: ["A", "B", "C", "D", "E", "F", "G"],
  986: ["A", "B", "C", "D", "E", "F"],
  987: ["A", "B", "C", "D", "E", "F"],
  988: ["A", "B", "C", "D", "E", "F"],
  989: ["A", "B", "C", "D", "E"],
  990: ["A", "B", "C", "D", "E", "F", "G"],
  991: ["A", "B", "C", "D", "E", "F"],
  992: ["A", "B", "C", "D", "E"],
  993: ["A", "B", "C", "D", "E", "F"],
  994: ["A", "B", "C", "D", "E", "F"],
  995: ["A", "B", "C", "D", "E", "F"],
  996: ["A", "B", "C", "D", "E", "F"],
  997: ["A", "B", "C", "D", "E"],
  998: ["A", "B", "C", "D", "E"],
  999: ["A", "B", "C", "D", "E", "F"],
  1000: ["A", "B", "C", "D", "E", "F", "G"],
  1001: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1002: [
    "A1",
    "A2",
    "A3",
    "A4",
    "B1",
    "B2",
    "B3",
    "B4",
    "C1",
    "C2",
    "D1",
    "D2",
    "D3",
    "E1",
    "E2",
  ],
  1003: ["A", "B", "C", "D", "E", "F"],
  1004: ["A", "B", "C", "D", "E", "F"],
  1005: ["A", "B", "C", "D", "E1", "E2", "F"],
  1006: ["A", "B", "C", "D", "E", "F"],
  1007: ["A", "B", "C", "D", "E"],
  1008: ["A", "B", "C", "D", "E"],
  1009: ["A", "B", "C", "D", "E", "F", "G"],
  1010: ["A", "B", "C", "D", "E", "F"],
  1011: ["A", "B", "C", "D", "E", "F"],
  1012: ["A", "B", "C", "D", "E", "F"],
  1013: ["A", "B", "C", "D", "E", "F"],
  1014: ["A2"],
  1015: ["A", "B", "C", "D", "E1", "E2", "F"],
  1016: ["A", "B", "C", "D", "E", "F", "G"],
  1017: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1018: [],
  1019: ["A", "B", "C", "D", "E"],
  1020: ["A", "B", "C", "D", "E"],
  1021: [],
  1022: [],
  1023: ["A", "B", "C", "D", "E", "F", "G"],
  1024: [],
  1025: ["A", "B", "C", "D", "E", "F", "G"],
  1026: [],
  1027: ["A", "B", "C", "D", "E", "F", "G"],
  1028: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1029: ["A", "B", "C", "D", "E", "F"],
  1030: ["A", "B", "C", "D", "E", "F", "G"],
  1031: ["A", "B", "C", "D", "E", "F"],
  1032: ["A", "B", "C", "D", "E", "F", "G"],
  1033: ["A", "B", "C", "D", "E", "F", "G"],
  1034: ["A", "B", "C", "D", "E"],
  1035: [],
  1036: ["A", "B", "C", "D", "E", "F", "G"],
  1037: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1038: ["A", "B", "C", "D", "E", "F"],
  1039: ["A", "B", "C", "D", "E"],
  1040: ["A", "B", "C", "D", "E"],
  1041: ["A", "B", "C", "D", "E", "F"],
  1042: ["A", "B", "C", "D", "E", "F"],
  1043: ["A", "B", "C", "D", "E", "F", "G"],
  1044: ["A", "B", "C", "D", "E", "F"],
  1045: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  1046: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  1047: ["A", "B", "C", "D", "E"],
  1048: [],
  1049: [],
  1050: [],
  1051: ["A", "B", "C", "D", "E", "F", "G"],
  1052: ["C"],
  1053: ["A", "B", "C", "D", "E"],
  1054: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1055: ["A", "B", "C", "D", "E", "F", "G"],
  1056: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1057: ["A", "B", "C"],
  1058: ["A", "B", "C", "D", "E", "F", "G"],
  1059: ["A", "B", "C", "D", "E"],
  1060: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1061: ["A", "B", "C", "D", "E", "F"],
  1062: ["A", "B", "C", "D", "E", "F"],
  1063: ["A", "B", "C", "D", "E", "F"],
  1064: ["A", "B", "C", "D", "E", "F"],
  1065: ["A", "B", "C", "D", "E", "F", "G"],
  1066: ["A", "B", "C", "D", "E", "F"],
  1067: ["A", "B", "C", "D", "E"],
  1068: ["A", "B", "C", "D", "E", "F"],
  1069: [],
  1070: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  1071: ["A", "B", "C", "D", "E"],
  1072: ["A", "B", "C", "D", "E", "F"],
  1073: ["A", "B", "C", "D", "E", "F", "G"],
  1074: ["A", "B", "C", "D", "E", "F"],
  1075: ["A", "B", "C", "D", "E", "F"],
  1076: ["A", "B", "C", "D", "E", "F", "G"],
  1077: ["A", "B", "C", "D", "E", "F1", "F2"],
  1078: ["A", "B", "C", "D", "E"],
  1079: ["A", "B", "C", "D", "E", "F", "G"],
  1080: ["A", "B", "C", "D", "E", "F"],
  1081: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1082: ["A", "B", "C", "D", "E", "F", "G"],
  1083: ["A", "B", "C", "D", "E", "F"],
  1084: ["A", "B", "C", "D", "E", "F"],
  1085: ["A", "B", "C", "D", "E", "F", "G"],
  1086: ["A", "B", "C", "D", "E", "F"],
  1087: ["A", "B", "C", "D", "E", "F"],
  1088: ["A", "B", "C", "D", "E", "F"],
  1089: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  1090: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  1091: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1092: ["A", "B", "C", "D1", "D2", "E", "F"],
  1093: ["A", "B", "C", "D", "E", "F", "G"],
  1094: [],
  1095: ["A", "B", "C", "D", "E", "F"],
  1096: ["A", "B", "C", "D", "E", "F", "G"],
  1097: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1098: ["A", "B", "C", "D", "E", "F"],
  1099: ["A", "B", "C", "D", "E", "F"],
  1100: ["A", "B", "C", "D", "E", "F"],
  1101: ["A", "B", "C", "D", "E", "F", "G"],
  1102: ["A", "B", "C", "D", "E", "F"],
  1103: ["A", "B", "C", "D", "E"],
  1104: ["A", "B", "C", "D", "E"],
  1105: ["A", "B", "C", "D", "E"],
  1106: ["A", "B", "C", "D", "E", "F"],
  1107: ["A", "B", "C", "D", "E", "F", "G"],
  1108: ["A", "B", "C", "D", "E1", "E2", "F"],
  1109: ["A", "B", "C", "D", "E", "F"],
  1110: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1111: ["A", "B", "C", "D", "E"],
  1112: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1113: ["A", "B", "C", "D", "E", "F"],
  1114: ["A", "B", "C", "D", "E", "F"],
  1115: ["G1", "G2", "G3", "U1", "U2", "U3"],
  1116: [
    "A1",
    "A2",
    "B1",
    "B2",
    "C1",
    "C2",
    "C3",
    "D1",
    "D2",
    "D3",
    "D4",
    "D5",
    "D6",
  ],
  1117: ["A", "B", "C", "D", "E", "F", "G"],
  1118: ["A", "B", "C", "D1", "D2", "E", "F1", "F2"],
  1119: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1120: ["A", "B", "C", "D", "E", "F"],
  1121: ["A", "B", "C", "D", "E", "F"],
  1122: [],
  1123: [],
  1124: [],
  1125: [],
  1126: [],
  1127: [],
  1128: [],
  1129: ["A1", "A2", "B", "C", "D", "E"],
  1130: ["A", "B", "C", "D1", "D2", "E"],
  1131: ["A", "B", "C", "D", "E", "F", "G"],
  1132: ["A", "B", "C", "D", "E", "F", "G"],
  1133: ["A", "B", "C", "D", "E", "F1", "F2"],
  1134: [],
  1135: [],
  1136: ["A", "B", "C", "D", "E"],
  1137: ["A", "B", "C", "D", "E", "F"],
  1138: ["A", "B", "C", "D", "E", "F"],
  1139: ["A", "B", "C", "D", "E", "F"],
  1140: ["A", "B", "C", "D", "E", "F", "G"],
  1141: ["A", "B", "C", "D", "E", "F1", "F2", "G"],
  1142: ["A", "B", "C", "D", "E"],
  1143: ["A", "B", "C", "D", "E", "F"],
  1144: ["A", "B", "C", "D", "E", "F", "G"],
  1145: ["A", "B", "C", "D", "E", "F", "G"],
  1146: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1147: ["A", "B", "C", "D", "E", "F"],
  1148: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1149: ["A", "B", "C", "D", "E"],
  1150: ["A", "B", "C", "D", "E"],
  1151: ["A", "B", "C", "D", "E", "F"],
  1152: ["A", "B", "C", "D", "E", "F1", "F2"],
  1153: ["A", "B", "C", "D", "E", "F"],
  1154: ["A", "B", "C", "D", "E", "F", "G"],
  1155: ["A", "B", "C", "D", "E", "F"],
  1156: ["A", "B", "C", "D", "E", "F", "G"],
  1157: ["A", "B", "C1", "C2", "D", "E", "F", "G"],
  1158: ["A", "B", "C", "D", "E", "F"],
  1159: ["A", "B", "C", "D", "E", "F"],
  1160: ["A2"],
  1161: ["A", "B", "C", "D", "E", "F"],
  1162: ["A", "B", "C", "D", "E", "F"],
  1163: ["A", "B1", "B2", "C1", "C2", "D", "E", "F"],
  1164: [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
  ],
  1165: ["A", "B", "C", "D", "E", "F1", "F2"],
  1166: ["A", "B", "C", "D", "E", "F"],
  1167: ["A", "B", "C", "D", "E", "F", "G"],
  1168: ["A", "B", "C", "D", "E"],
  1169: ["A", "B", "C", "D", "E"],
  1170: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1171: ["A", "B", "C", "D", "E", "F"],
  1172: ["A", "B", "C1", "C2", "D", "E", "F"],
  1173: ["A", "B", "C", "D", "E1", "E2", "F"],
  1174: ["A", "B", "C", "D", "E", "F"],
  1175: ["A", "B", "C", "D", "E", "F", "G"],
  1176: ["A", "B", "C", "D", "E", "F"],
  1177: ["A", "B"],
  1178: ["A", "B", "C", "D", "E", "F1", "F2", "G", "H"],
  1179: ["A", "B", "C", "D", "E"],
  1180: ["A", "B", "C", "D", "E"],
  1181: ["A", "B", "C", "D", "E1", "E2"],
  1182: ["A", "B", "C", "D", "E", "F"],
  1183: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1184: [
    "A1",
    "A2",
    "A3",
    "B1",
    "B2",
    "B3",
    "C1",
    "C2",
    "C3",
    "D1",
    "D2",
    "E1",
    "E2",
    "E3",
  ],
  1185: ["A", "B", "C1", "C2", "D", "E", "F", "G1", "G2"],
  1186: ["A", "C", "D", "E", "F"],
  1187: ["A", "B", "C", "D", "E", "F", "G"],
  1188: ["A1", "A2", "B", "C", "D", "E"],
  1189: ["A", "B", "C", "D1", "D2", "E", "F"],
  1190: ["A", "B", "C", "D", "E", "F"],
  1191: ["A", "B", "C", "D", "E", "F"],
  1192: ["A", "B", "C"],
  1193: ["A", "B", "C"],
  1194: ["A", "B", "C", "D", "E", "F", "G"],
  1195: ["A", "B", "C", "D1", "D2", "E", "F"],
  1196: ["A", "B", "C", "D1", "D2", "E", "F"],
  1197: ["A", "B", "C", "D", "E", "F"],
  1198: ["A", "B", "C", "D", "E", "F"],
  1199: ["A", "B", "C", "D", "E", "F"],
  1200: ["A", "B", "C", "D", "E", "F"],
  1201: ["A", "B", "C", "D", "E1", "E2"],
  1202: ["A", "B", "C", "D", "E", "F"],
  1203: ["A", "B", "C", "D1", "D2", "E", "F1", "F2"],
  1204: ["A", "B", "C", "D1", "D2", "E"],
  1205: ["A", "B", "C", "D", "E", "F"],
  1206: ["A", "B", "C", "D", "E", "F"],
  1207: ["A", "B", "C", "D", "E", "F", "G"],
  1208: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1209: ["A", "B", "C", "D", "E1", "E2", "F", "G1", "G2", "H"],
  1210: ["A", "B", "C", "D", "E", "F1", "F2", "G"],
  1211: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1212: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1213: ["A", "B", "C", "D1", "D2", "E", "F", "G"],
  1214: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1215: ["A", "B", "C", "D", "E", "F"],
  1216: ["A", "B", "C", "D", "E1", "E2", "F"],
  1217: ["A", "B", "C", "D", "E", "F"],
  1218: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1219: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1220: ["A", "B", "C", "D", "E", "F", "G"],
  1221: ["A", "B", "C", "D", "E", "F", "G"],
  1222: [],
  1223: ["A", "B", "C", "D", "E", "F", "G"],
  1224: [],
  1225: ["A", "B1", "B2", "C", "D", "E", "F", "G"],
  1226: [],
  1227: ["A", "B", "C", "D1", "D2", "E", "F1", "F2", "G"],
  1228: ["A", "B", "C", "D", "E", "F"],
  1229: ["A", "B", "C", "D", "E1", "E2", "F"],
  1230: ["A", "B", "C", "D", "E", "F"],
  1231: ["A", "B", "C", "D", "E", "F", "G"],
  1232: [],
  1233: [],
  1234: ["A", "B1", "B2", "C", "D", "E", "F"],
  1235: ["A3", "B3", "C3"],
  1236: ["A", "B", "C", "D", "E", "F"],
  1237: ["A", "B", "C1", "C2", "D", "E", "F", "G", "H"],
  1238: ["A", "B", "C", "D", "E", "F", "G"],
  1239: ["A", "B", "C", "D", "E", "F"],
  1240: ["A", "B", "C", "D", "E", "F"],
  1241: ["A", "B", "C", "D", "E", "F"],
  1242: ["A", "B", "C", "D", "E"],
  1243: ["A", "B1", "B2", "C", "D", "E"],
  1244: ["A", "B", "C", "D", "E", "F", "G"],
  1245: ["A", "B", "C", "D", "E", "F"],
  1246: ["A", "B", "C", "D", "E", "F"],
  1247: ["A", "B1", "B2", "C", "D", "E", "F"],
  1248: ["A", "B", "C", "D1", "D2", "E", "F"],
  1249: ["A", "B1", "B2", "C1", "C2", "D1", "D2", "E", "F"],
  1250: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"],
  1251: ["A", "B", "C", "D", "E1", "E2", "F"],
  1252: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
  1253: ["A", "B", "C", "D", "E", "F"],
  1254: ["A", "B1", "B2", "C", "D", "E"],
  1255: ["A", "B", "C", "D", "E1", "E2", "F"],
  1256: ["A", "B", "C", "D", "E", "F"],
  1257: ["A", "B", "C", "D", "E", "F", "G"],
  1258: [],
  1259: ["A", "B", "C", "D", "E", "F", "G"],
  1260: ["A", "B", "C", "D", "E", "F"],
  1261: ["A", "B1", "B2", "C", "D1", "D2", "E", "F"],
  1262: ["A", "B", "C", "D1", "D2", "E", "F1", "F2"],
  1263: ["A", "B", "C", "D", "E", "F"],
  1264: ["A", "B", "C", "D1", "D2", "E", "F"],
  1265: ["A", "B", "C", "D", "E", "F"],
  1266: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1267: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
  1268: ["A", "B", "C", "D", "E"],
  1269: ["A", "B", "C", "D", "E"],
  1270: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1271: ["A", "B", "C", "D", "E", "F"],
  1272: ["A", "B", "C", "D", "E", "F"],
  1273: ["A", "B", "C", "D"],
  1274: ["A", "B"],
  1275: ["A", "B", "C", "D", "E1", "E2", "E3", "F"],
  1276: ["A", "B", "C", "D", "E", "F"],
  1277: ["A", "B", "C", "D", "E", "F"],
  1278: ["A", "B", "C", "D", "E", "F"],
  1279: ["A", "B", "C", "D", "E", "F"],
  1280: ["A", "B", "C", "D", "E", "F"],
  1281: ["A", "B", "C", "D", "E", "F"],
  1282: ["A", "B1", "B2", "C", "D", "E"],
  1283: ["A", "B", "C", "D", "E", "F"],
  1284: ["A", "B", "C", "D", "E", "F", "G"],
  1285: ["A", "B", "C", "D", "E", "F"],
  1286: ["A", "B", "C1", "C2", "D", "E", "F"],
  1287: ["A", "B", "C", "D", "E1", "E2", "F"],
  1288: ["A", "B", "C", "D", "E", "F"],
  1289: [],
  1290: ["A", "B", "C", "D", "E", "F"],
  1291: ["A", "B", "C", "D", "E", "F"],
  1292: ["A", "B", "C", "D", "E", "F"],
  1293: ["A", "B", "C", "D", "E", "F"],
  1294: ["A", "B", "C", "D", "E", "F"],
  1295: ["A", "B", "C", "D", "E", "F"],
  1296: ["A", "B", "C", "D", "E1", "E2", "F"],
  1297: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1298: ["A", "B", "C", "D", "E", "F1", "F2"],
  1299: ["A", "B", "C", "D", "E"],
  1300: ["A", "B", "C", "D", "E"],
  1301: ["A", "B", "C", "D", "E", "F"],
  1302: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  1303: ["A", "B", "C", "D", "E", "F", "G"],
  1304: ["A", "B", "C", "D", "E", "F1", "F2"],
  1305: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1306: [],
  1307: ["A", "B", "C", "D", "E", "F", "G"],
  1308: ["A"],
  1309: ["A", "B", "C", "D", "E", "F", "G"],
  1310: ["A", "B", "C", "D", "E", "F"],
  1311: ["A", "B", "C", "D", "E", "F"],
  1312: ["A", "B", "C", "D", "E", "F", "G"],
  1313: ["A", "B", "C1", "C2", "D", "E"],
  1314: ["A", "B", "C", "D", "E", "F"],
  1315: ["A", "B", "C", "D", "E", "F"],
  1316: ["A", "B", "C", "D", "E", "F"],
  1317: [],
  1318: [],
  1319: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1320: ["A", "B", "C", "D", "E", "F"],
  1321: ["A", "B", "C", "D", "E", "F"],
  1322: ["A", "B", "C", "D", "E", "F"],
  1323: ["A", "B", "C", "D", "E", "F"],
  1324: ["A", "B", "C", "D", "E", "F"],
  1325: ["A", "B", "C", "D", "E", "F"],
  1326: ["A", "B", "C", "D1", "D2", "E", "F1", "F2", "G"],
  1327: ["A", "B", "C", "D", "E", "F", "G"],
  1328: ["A", "B", "C", "D", "E", "F"],
  1329: ["A", "B", "C", "D", "E"],
  1330: ["A", "B", "C", "D", "E"],
  1331: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1332: ["A", "B", "C", "D", "E", "F", "G"],
  1333: ["A", "B", "C", "D", "E", "F"],
  1334: ["A", "B", "C", "D", "E", "F", "G"],
  1335: ["A", "B", "C", "D", "E1", "E2", "F"],
  1336: ["A", "B", "C", "D", "E1", "E2", "F"],
  1337: ["A", "B", "C", "D", "E", "F"],
  1338: ["A", "B", "C", "D", "E"],
  1339: ["A", "B", "C", "D", "E"],
  1340: ["A", "B", "C", "D", "E", "F"],
  1341: ["A", "B", "C", "D", "E", "F"],
  1342: ["A", "B", "C", "D", "E", "F"],
  1343: ["A", "B", "C", "D", "E", "F"],
  1344: ["A", "B", "C", "D", "E", "F"],
  1345: ["A", "B", "C", "D", "E", "F"],
  1348: ["A", "B", "C", "D", "E", "F"],
  1349: ["A", "B", "C", "D", "E", "F1", "F2"],
  1350: ["A", "B", "C", "D", "E", "F"],
  1351: ["A", "B", "C"],
  1352: ["A", "B", "C", "D", "E", "F", "G"],
  1353: ["A", "B", "C", "D", "E", "F"],
  1354: ["A", "B", "C1", "C2", "D", "E", "F", "G"],
  1355: ["A", "B", "C", "D", "E", "F"],
  1356: ["A1", "A2", "A3", "A4", "A5", "B1", "B2", "C", "D1", "D2"],
  1357: [],
  1358: ["A", "B", "C", "D", "E", "F"],
  1359: ["A", "B", "C", "D", "E", "F"],
  1360: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1361: ["A", "B", "C", "D", "E", "F"],
  1362: ["A", "B", "C", "D", "E", "F"],
  1363: ["A", "B", "C", "D", "E", "F"],
  1364: ["A", "B", "C", "D", "E"],
  1365: ["A", "B", "C", "D", "E", "F", "G"],
  1366: ["A", "B", "C", "D", "E", "F", "G"],
  1367: ["A", "B", "C", "D", "E", "F1", "F2"],

  1368: ["A", "B", "C", "D", "E", "F", "G", "H1", "H2"],
  1369: ["A", "B", "C", "D", "E", "F"],
  1370: ["A", "B", "C", "D", "E", "F1", "F2"],
  1371: ["A", "B", "C", "D", "E1", "E2", "F"],
  1372: ["A", "B", "C", "D", "E", "F"],
  1373: ["A", "B", "C", "D", "E", "F", "G"],
  1374: ["A", "B", "C", "D", "E1", "E2", "F"],
  1375: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1376: ["A1", "B1", "B2", "B3", "B4"],
  1377: ["A1", "A2", "A3"],
  1378: ["A1", "A2", "A3"],
  1379: ["A", "B", "C", "D", "E", "F1", "F2"],
  1380: ["A", "B", "C", "D", "E", "F", "G"],
  1381: ["A1", "A2", "B", "C", "D", "E"],
  1382: ["A", "B", "C1", "C2", "D", "E"],
  1383: ["A", "B", "C", "D", "E", "F"],
  1384: ["A", "B1", "B2", "C", "D", "E", "F"],
  1385: ["A", "B", "C", "D", "E", "F", "G"],
  1386: ["A", "B", "C"],
  1387: ["A", "B1", "B2", "C"],
  1388: ["A", "B", "C", "D", "E"],
  1389: ["A", "B", "C", "D", "E", "F", "G"],
  1390: [],
  1391: ["A", "B", "C", "D", "E"],
  1392: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1393: ["A", "B", "C", "D", "E1", "E2"],
  1394: ["A", "B", "C", "D", "E"],
  1395: ["A", "B", "C", "D", "E", "F"],
  1396: ["A", "B", "C", "D", "E"],
  1397: ["A", "B", "C", "D", "E"],
  1398: ["A", "B", "C", "D", "E", "F", "G"],
  1399: ["A", "B", "C", "D", "E1", "E2", "F"],
  1400: ["A", "B", "C", "D", "E", "F", "G"],
  1401: ["A", "B", "C", "D", "E", "F"],
  1402: ["A", "B", "C"],
  1403: ["A", "B", "C"],
  1404: ["A", "B", "C", "D", "E"],
  1405: ["A", "B", "C", "D", "E"],
  1406: ["A", "B", "C", "D", "E"],
  1407: ["A", "B", "C", "D", "E"],
  1408: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1409: ["A", "B", "C", "D", "E", "F"],
  1410: [],
  1411: [],
  1412: [],
  1413: ["A", "B", "C", "D", "E", "F"],
  1414: [],
  1415: [],
  1416: ["A", "B", "C", "D", "E", "F"],
  1417: ["A", "B", "C", "D", "E", "F"],
  1418: ["A", "B", "C", "D", "E", "F", "G"],
  1419: ["A", "B", "C", "D1", "D2", "E", "F"],
  1420: ["A", "B", "C1", "C2", "D", "E"],
  1421: ["A", "B", "C", "D", "E"],
  1422: ["A", "B", "C", "D", "E", "F"],
  1423: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"],
  1424: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"],
  1425: ["A", "B", "C", "D", "E", "F", "H", "I"],
  1426: ["A", "B", "C", "D", "E", "F"],
  1427: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1428: ["A", "B", "C", "D", "E", "F", "G1", "G2", "H"],
  1429: [],
  1430: ["A", "B", "C", "D", "E", "F", "G"],
  1431: [],
  1432: [],
  1433: ["A", "B", "C", "D", "E", "F", "G"],
  1434: ["A", "B", "C", "D", "E"],
  1435: ["A", "B", "C", "D", "E"],
  1436: ["A", "B", "C", "D", "E", "F"],
  1437: ["A", "B", "C", "D", "E", "F", "G"],
  1438: [],
  1439: [],
  1440: [],
  1441: ["A", "B", "C", "D", "E", "F"],
  1442: ["A", "B", "C", "D", "E", "F"],
  1443: ["A", "B", "C", "D", "E", "F"],
  1444: ["A", "B", "C", "D", "E"],
  1445: ["A", "B", "C", "D", "E"],
  1446: ["A", "B", "C", "D1", "D2", "E", "F"],
  1447: ["A", "B", "C", "D", "E", "F1", "F2"],
  1448: [],
  1449: [],
  1450: ["A", "B", "C1", "C2", "D", "E", "F", "G", "H1", "H2"],
  1451: ["A", "B", "C", "D", "E1", "E2", "F"],
  1452: ["A", "B", "C", "D", "E", "F", "G"],
  1453: ["A", "B", "C", "D", "E", "F"],
  1454: ["A", "B", "C", "D", "E", "F"],
  1455: ["A", "B", "C", "D", "E", "F", "G"],
  1456: ["A", "B", "C", "D", "E"],
  1457: ["A", "B", "C", "D", "E"],
  1458: ["A", "B", "C", "D", "E", "F"],
  1459: ["A", "B", "C", "D", "E", "F"],
  1460: ["A"],
  1461: ["A", "B", "C", "D", "E", "F"],
  1462: ["A", "B", "C", "D", "E1", "E2", "F"],
  1463: ["A", "B", "C", "D", "E", "F"],
  1464: ["A", "B", "C", "D", "E", "F"],
  1465: ["A", "B", "C", "D", "E", "F"],
  1466: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1467: ["A", "B", "C", "D", "E"],
  1468: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"],
  1469: ["A", "B", "C", "D", "E", "F"],
  1470: ["A", "B", "C", "D", "E", "F"],
  1471: ["A", "B", "C", "D", "E", "F"],
  1472: ["A", "B", "C", "D", "E", "F", "G"],
  1473: ["A", "B", "C", "D", "E", "F", "G"],
  1474: ["A", "B", "C", "D", "E", "F"],
  1475: ["A", "B", "C", "D", "E", "F", "G"],
  1476: ["A", "B", "C", "D", "E", "F", "G"],
  1477: ["A", "B", "C", "D", "E", "F"],
  1478: ["A", "B", "C", "D", "E", "F"],
  1479: ["A", "B1", "B2", "C", "D", "E"],
  1480: ["A", "B", "C", "D1", "D2", "E"],
  1481: ["A", "B", "C", "D", "E", "F"],
  1482: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1483: ["A", "B", "C", "D", "E", "F"],
  1484: ["A", "B", "C", "D", "E", "F"],
  1485: ["A", "B", "C", "D", "E", "F"],
  1486: ["A", "B", "C1", "C2", "D", "E", "F"],
  1487: ["A", "B", "C", "D", "E", "F", "G"],
  1488: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  1489: ["A", "B", "C", "D", "E", "F", "G"],
  1490: ["A", "B", "C", "D", "E", "F", "G"],
  1491: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1492: ["A", "B", "C", "D", "E"],
  1493: ["A", "B", "C", "D", "E", "F"],
  1494: ["A", "B", "C", "D", "E", "F"],
  1495: ["A", "B", "C", "D", "E", "F"],
  1496: ["A", "B", "C", "D", "E", "F"],
  1497: ["A", "B", "C1", "C2", "D", "E1", "E2"],
  1498: ["A", "B", "C", "D", "E", "F"],
  1499: ["A", "B", "C", "D", "E", "F", "G"],
  1500: ["A", "B", "C", "D", "E", "F"],
  1501: ["A", "B", "C", "D", "E", "F"],
  1502: [],
  1503: ["A", "B", "C", "D", "E", "F"],
  1504: ["A", "B", "C", "D", "E", "F"],
  1505: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1506: ["A", "B", "C", "D", "E", "F", "G"],
  1507: [],
  1508: ["A", "B", "C", "D", "E", "F"],
  1509: ["A", "B", "C", "D", "E", "F"],
  1510: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
  1511: ["A", "B", "C", "D", "E", "F", "G"],
  1512: ["A", "B", "C", "D", "E", "F", "G"],
  1513: ["A", "B", "C", "D", "E", "F"],
  1514: ["A", "B", "C", "D", "E"],
  1515: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1516: ["A", "B", "C", "D", "E"],
  1517: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1518: [],
  1519: ["A", "B", "C", "D", "E", "F"],
  1520: ["A", "B", "C", "D", "E", "F1", "F2", "G"],
  1521: ["A", "B", "C", "D", "E"],
  1522: ["A"],
  1523: [],
  1524: [],
  1525: ["A", "B", "C", "D", "E", "F"],
  1526: [],
  1527: ["A", "B1", "B2", "C", "D", "E"],
  1528: ["A", "B", "C", "D", "E", "F"],
  1529: ["A", "B", "C", "D", "E", "F"],
  1530: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1531: ["A", "B1", "B2", "C", "D", "E1", "E2", "E3"],
  1532: ["A", "B", "C", "D", "E", "F"],
  1533: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  1534: ["A", "B", "C", "D", "E", "F1", "F2", "G", "H"],
  1535: ["A", "B", "C", "D", "E", "F"],
  1536: ["A", "B", "C", "D", "E", "F"],
  1537: ["A", "B", "C", "D", "E1", "E2", "F"],
  1538: ["A", "B", "C", "D", "E", "F", "G"],
  1539: ["A", "B", "C", "D", "E", "F"],
  1540: ["A", "B", "C1", "C2", "D", "E"],
  1541: ["A", "B", "C", "D", "E1", "E2"],
  1542: ["A", "B", "C", "D", "E1", "E2"],
  1543: ["A", "B", "C", "D1", "D2", "E"],
  1544: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1545: ["A", "B", "C", "D", "E1", "E2", "F"],
  1546: ["A", "B", "C", "D", "E", "F"],
  1547: ["A", "B", "C", "D", "E", "F", "G"],
  1548: ["A", "B", "C", "D1", "D2", "E"],
  1549: ["A", "B", "C", "D", "E", "F1", "F2"],
  1550: ["A", "B", "C", "D", "E", "F"],
  1551: ["A", "B1", "B2", "C", "D1", "D2", "E", "F"],
  1552: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1553: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1554: ["A", "B", "C", "D", "E"],
  1555: ["A", "B", "C", "D", "E", "F"],
  1556: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1557: ["A", "B", "C", "D", "E"],
  1558: ["A", "B", "C", "D", "E", "F"],
  1559: ["A", "B", "C", "D1", "D2", "E"],
  1560: ["A", "B", "C", "D", "E", "F1", "F2"],
  1561: ["A", "B", "C", "D1", "D2", "E", "F"],
  1562: ["A", "B", "C", "D1", "D2", "E", "F"],
  1563: ["A", "B", "C", "D", "E", "F"],
  1564: [],
  1565: [],
  1566: ["A", "B", "C", "D1", "D2", "E", "F", "G", "H"],
  1567: ["A", "B", "C", "D", "E", "F"],
  1568: [],
  1569: ["A", "B", "C", "D", "E", "F"],
  1570: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1571: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  1572: ["A", "B", "C", "D", "E", "F"],
  1573: ["A", "B", "C", "D", "E", "F"],
  1574: ["A", "B", "C", "D", "E", "F"],
  1575: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  1576: ["A"],
  1577: [],
  1578: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  1579: ["A", "B", "C", "D", "E1", "E2", "F", "G"],
  1580: ["A", "B", "C", "D", "E", "F"],
  1581: ["A", "B", "C", "D", "E", "F"],
  1582: ["A", "B", "C", "D", "E", "F1", "F2", "G"],
  1583: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1584: ["A", "B", "C", "D", "E", "F", "G"],
  1585: ["A", "B", "C", "D", "E", "F", "G"],
  1586: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1587: [],
  1588: ["A", "B", "C", "D", "E", "F"],
  1589: ["A", "B", "C", "D", "E", "F"],
  1590: [],
  1591: ["A", "B", "C", "D", "E", "F"],
  1592: ["A", "B", "C", "D", "E", "F1", "F2"],
  1593: ["A", "B", "C", "D1", "D2", "E", "F", "G"],
  1594: ["A", "B", "C", "D", "E1", "E2", "F"],
  1595: [],
  1596: [],
  1597: [],
  1598: ["A", "B", "C", "D", "E", "F", "G"],
  1599: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  1600: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  1601: ["A", "B", "C", "D", "E", "F"],
  1602: ["A", "B", "C", "D", "E", "F"],
  1603: ["A", "B", "C", "D", "E", "F"],
  1604: ["A", "B", "C", "D", "E", "F"],
  1605: ["A", "B", "C", "D", "E", "F"],
  1606: ["A", "B", "C", "D", "E", "F"],
  1607: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1608: ["A", "B", "C", "D", "E", "F", "G"],
  1609: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1610: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1611: ["A", "B", "C", "D", "E1", "E2", "F", "G"],
  1612: ["A", "B", "C", "D", "E", "F", "G"],
  1613: ["A", "B", "C", "D", "E", "F"],
  1614: ["A", "B", "C", "D1", "D2", "E"],
  1615: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1616: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1617: ["A", "B", "C", "D1", "D2", "E"],
  1618: ["A", "B", "C", "D", "E", "F", "G"],
  1619: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1620: ["A", "B", "C", "D", "E", "F", "G"],
  1621: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1622: ["A", "B", "C", "D", "E", "F"],
  1623: ["A", "B", "C", "D", "E"],
  1624: ["A", "B", "C", "D", "E", "F", "G"],
  1625: ["A", "B", "C", "D", "E1", "E2"],
  1626: ["A", "B", "C", "D", "E", "F"],
  1627: ["A", "B", "C", "D", "E", "F"],
  1628: ["A", "B", "C", "D1", "D2", "E", "F"],
  1629: ["A", "B", "C", "D", "E", "F1", "F2"],
  1630: ["A", "B", "C", "D", "E", "F"],
  1631: ["A", "B", "C", "D", "E", "F"],
  1632: ["A", "B", "C", "D", "E1", "E2"],
  1633: ["A", "B", "C", "D", "E", "F"],
  1634: ["A", "B", "C", "D", "E", "F"],
  1635: ["A", "B", "C", "D", "E", "F"],
  1636: [],
  1637: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1638: ["A", "B", "C", "D", "E", "F"],
  1639: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
  1640: [],
  1641: ["A", "B", "C", "D", "E", "F"],
  1642: ["A", "B", "C", "D", "E", "F"],
  1643: [],
  1644: ["A", "B", "C", "D", "E", "F"],
  1645: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1646: ["A", "B", "C", "D", "E", "F"],
  1647: ["A", "B", "C", "D", "E", "F"],
  1648: ["A", "B", "C", "D", "E", "F"],
  1649: ["A", "B", "C", "D", "E", "F"],
  1650: ["A", "B", "C", "D", "E", "F", "G"],
  1651: ["A", "B", "C", "D", "E", "F"],
  1652: ["A", "B", "C", "D", "E", "F", "G"],
  1653: [],
  1654: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1655: [],
  1656: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1657: ["A", "B", "C", "D", "E", "F"],
  1658: ["A", "B", "C", "D1", "D2", "E", "F"],
  1659: ["A", "B", "C", "D", "E", "F"],
  1660: ["A", "B", "C", "D", "E", "F1", "F2"],
  1661: ["A", "B", "C", "D", "E", "F"],
  1662: [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
  ],
  1663: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1664: [],
  1665: ["A", "B", "C", "D", "E"],
  1666: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
  1667: ["A", "B", "C", "D", "E", "F"],
  1668: ["A", "B", "C", "D", "E", "F"],
  1669: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1670: ["A", "B", "C", "D", "E", "F"],
  1671: ["A", "B", "C", "D", "E", "F"],
  1672: ["A", "B", "C", "D", "E", "F1", "F2", "G", "H", "I"],
  1673: ["A", "B", "C", "D", "E", "F"],
  1674: ["A", "B", "C", "D", "E", "F", "G"],
  1675: ["A", "B", "C", "D", "E", "F", "G"],
  1676: ["A", "B", "C", "D", "E", "F", "G", "H1", "H2"],
  1677: ["A", "B", "C", "D", "E", "F"],
  1678: ["A", "B1", "B2", "C", "D", "E", "F"],
  1679: ["A", "B", "C", "D", "E", "F"],
  1680: ["A", "B", "C", "D", "E", "F"],
  1681: ["A", "B", "C", "D", "E", "F"],
  1682: ["A", "B", "C", "D", "E", "F"],
  1683: [],
  1684: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1685: ["A", "B", "C", "D1", "D2", "E"],
  1686: ["A", "B", "C", "D", "E", "F"],
  1687: ["A", "B", "C", "D", "E", "F"],
  1688: ["A", "B", "C", "D", "E", "F"],
  1689: ["A", "B", "C", "D", "E"],
  1690: ["A", "B", "C", "D", "E", "F", "G"],
  1691: ["A", "B", "C", "D", "E", "F"],
  1692: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1693: ["A", "B", "C", "D", "E", "F"],
  1694: ["A", "B", "C", "D", "E", "F"],
  1695: ["A", "B", "C", "D1", "D2", "E"],
  1696: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1697: ["A", "B", "C", "D", "E", "F"],
  1698: ["A", "B", "C", "D", "E", "F", "G"],
  1699: ["A", "B", "C", "D", "E"],
  1700: ["A", "B", "C", "D", "E", "F"],
  1701: ["A", "B", "C", "D", "E", "F"],
  1702: ["A", "B", "C", "D", "E", "F", "G1", "G2"],
  1703: ["A", "B", "C", "D", "E", "F", "G"],
  1704: ["A", "B", "C", "D", "E", "F", "G", "H1", "H2"],
  1705: ["A", "B", "C", "D", "E", "F"],
  1706: ["A", "B", "C", "D1", "D2", "E"],
  1707: ["A", "B", "C", "D", "E", "F"],
  1708: ["A", "B", "C", "D", "E", "F"],
  1709: ["A", "B", "C", "D", "E", "F"],
  1710: ["A", "B", "C", "D", "E"],
  1711: ["A", "B", "C", "D", "E"],
  1712: ["A", "B", "C", "D", "E1", "E2", "F"],
  1713: ["A", "B", "C", "D", "E", "F"],
  1714: ["A", "B", "C", "D", "E", "F", "G"],
  1715: ["A", "B", "C", "D", "E", "F"],
  1716: ["A", "B", "C", "D", "E", "F"],
  1717: ["A", "B", "C", "D", "E", "F"],
  1718: ["A1", "A2", "B", "C", "D", "E", "F"],
  1719: ["A", "B", "C", "D1", "D2", "E", "F"],
  1720: ["A", "B", "C", "D1", "D2", "E"],
  1721: ["A", "B", "C", "D", "E", "F"],
  1722: ["A", "B", "C", "D", "E", "F", "G"],
  1723: ["GP1", "GP2"],
  1724: ["A"],
  1725: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  1726: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1727: [],
  1728: ["A", "B", "C", "D", "E", "F", "G"],
  1729: ["A", "B", "C", "D", "E", "F", "G"],
  1730: ["A", "B", "C", "D", "E", "F"],
  1731: ["A", "B", "C", "D", "E", "F"],
  1732: ["A", "B", "C1", "C2", "D1", "D2", "E"],
  1733: ["A", "B", "C", "D1", "D2", "E"],
  1734: ["A", "B", "C", "D", "E", "F"],
  1735: ["A", "B", "C", "D", "E", "F"],
  1736: ["A", "B", "C1", "C2", "D", "E"],
  1737: ["A", "B", "C", "D", "E", "F", "G"],
  1738: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1739: ["A", "B", "C", "D", "E", "F"],
  1740: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1741: ["A", "B", "C", "D", "E", "F", "G"],
  1742: ["A", "B", "C", "D", "E", "F", "G"],
  1743: ["A", "B", "C", "D", "E", "F", "G"],
  1744: ["A", "B", "C", "D", "E1", "E2", "F"],
  1745: [],
  1746: ["A", "B", "C", "D", "E1", "E2", "F", "G"],
  1747: ["A", "B", "C", "D", "E"],
  1748: ["A", "B", "C", "D", "E", "F"],
  1749: ["A", "B", "C", "D", "E", "F"],
  1750: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1751: ["A"],
  1752: ["A"],
  1753: ["A1", "A2", "B", "C", "D", "E", "F"],
  1754: ["A", "B", "C1", "C2", "D", "E", "F"],
  1755: ["A", "B", "C", "D", "E", "F"],
  1756: [],
  1757: [],
  1758: ["A", "B", "C", "D", "E", "F"],
  1759: ["A", "B", "C", "D", "E", "F", "G"],
  1760: ["A", "B", "C", "D", "E", "F", "G"],
  1761: ["A", "B", "C", "D", "E", "F1", "F2", "G"],
  1762: ["A", "B", "C", "D", "E", "F", "G"],
  1763: ["A", "B", "C", "D", "E", "F"],
  1764: ["A", "B", "C", "D", "E", "F", "G1", "G2", "G3", "H"],
  1765: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"],
  1766: ["A", "B", "C", "D", "E", "F"],
  1767: ["A", "B", "C", "D", "E", "F"],
  1768: ["A", "B", "C", "D", "E", "F"],
  1769: ["A", "B1", "B2", "C1", "C2", "D1", "D2", "D3"],
  1770: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1771: ["A", "B", "C", "D", "E", "F"],
  1772: ["A", "B", "C", "D", "E", "F", "G"],
  1773: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
  1774: ["A", "B", "C", "D", "E", "F1", "F2", "G", "H"],
  1775: ["A1", "A2", "B", "C", "D", "E", "F"],
  1776: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"],
  1777: ["A", "B", "C", "D", "E", "F"],
  1778: ["A", "B", "C", "D", "E", "F"],
  1779: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1780: ["A", "B", "D", "E", "F", "G"],
  1781: ["A", "B", "C", "D", "E", "F", "G", "H1", "H2"],
  1782: ["A", "B", "C", "D", "E", "F", "G", "H1", "H2"],
  1783: ["A", "B", "C", "D", "E", "F", "G"],
  1784: ["A", "B", "C", "D", "E", "F"],
  1785: ["A", "B", "C", "D", "E", "F"],
  1786: ["A1", "A2", "B", "C", "D", "E", "F"],
  1787: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1788: ["A", "B", "C", "D", "E", "F"],
  1789: ["A", "B", "C", "D", "E", "F"],
  1790: ["A", "B", "C", "D", "E", "F", "G"],
  1791: ["A", "B", "C", "D", "E", "F", "G1", "G2"],
  1792: ["A", "B", "C", "D", "E", "F1", "F2"],
  1793: ["A", "B", "C", "D", "E", "F"],
  1794: ["A", "B", "C", "D", "E"],
  1795: ["A", "B", "C", "D", "E", "F", "G"],
  1796: ["A", "B", "C", "D", "E", "F"],
  1797: ["A", "B", "C", "D", "E", "F"],
  1798: ["A", "B", "C", "D", "E", "F"],
  1799: ["A", "B", "C", "D1", "D2", "E", "F", "G", "H"],
  1800: ["A", "B", "C1", "C2", "D", "E1", "E2", "F", "G"],
  1801: ["A", "B", "C", "D", "E", "F", "G"],
  1802: ["A", "B", "C", "D", "E", "F", "G"],
  1803: [],
  1804: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1805: ["A", "B", "C", "D", "E", "F1", "F2"],
  1806: ["A", "B", "C", "D", "E", "F1", "F2"],
  1807: ["A", "B", "C", "D", "E", "F", "G1", "G2"],
  1808: ["A", "B", "C", "D", "E1", "E2", "E3"],
  1809: ["A", "B", "C", "D", "E", "F", "G"],
  1810: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1811: ["A", "B", "C", "D", "E", "F", "G1", "G2"],
  1812: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  1813: ["A"],
  1814: ["A", "B", "C", "D", "E", "F"],
  1815: ["A", "B", "C", "D", "E", "F"],
  1816: ["A", "B", "C", "D", "E", "F"],
  1817: ["A", "B", "C", "D", "E", "F"],
  1818: ["A", "B", "C", "D", "E", "F"],
  1819: ["A", "B", "C", "D", "E", "F"],
  1820: ["A", "B", "C", "D", "E", "F"],
  1821: ["A", "B", "C", "D", "E", "F"],
  1822: ["A", "B", "C", "D", "E", "F", "G1", "G2"],
  1823: ["A", "B", "C", "D", "E", "F"],
  1824: ["A", "B1", "B2", "C", "D", "E"],
  1825: ["A", "B", "C", "D1", "D2", "E"],
  1826: ["A", "B", "C", "D", "E", "F"],
  1827: ["A", "B1", "B2", "C", "D", "E", "F"],
  1828: ["A", "B", "C", "D1", "D2", "E", "F"],
  1829: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1830: ["A", "B", "C", "D", "E", "F"],
  1831: ["A", "B", "C", "D", "E", "F"],
  1832: ["A", "B", "C", "D1", "D2", "E", "F"],
  1833: ["A", "B", "C", "D", "E", "F", "G"],
  1834: ["A", "B", "C", "D", "E", "F"],
  1835: ["A", "B", "C", "D", "E", "F"],
  1836: ["A", "B", "C", "D", "E", "F"],
  1837: ["A", "B", "C", "D", "E", "F"],
  1838: ["A", "B", "C", "D", "E", "F"],
  1839: ["A", "B", "C", "D", "E"],
  1840: ["A", "B", "C", "D", "E", "F", "G1", "G2"],
  1841: ["A", "B", "C", "D", "E", "F"],
  1842: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1843: ["A", "B", "C", "D", "E", "F1", "F2"],
  1844: ["A", "B", "C", "D", "E", "F1", "F2", "G", "H"],
  1845: ["A", "B", "C", "D", "E", "F"],
  1846: ["A", "B", "C", "D", "E1", "E2", "F", "G"],
  1847: ["A", "B", "C", "D", "E", "F"],
  1848: ["A", "B", "C", "D", "E", "F"],
  1849: ["A", "B", "C", "D", "E", "F"],
  1850: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1851: ["A", "B", "C", "D", "E", "F", "G"],
  1852: ["A", "B", "C", "D", "E", "F"],
  1853: ["A", "B", "C", "D", "E", "F"],
  1854: ["A1", "A2", "B", "C", "D", "E", "F"],
  1855: ["A", "B", "C1", "C2", "D", "E", "F"],
  1856: ["A", "B", "C", "D", "E1", "E2"],
  1857: ["A", "B", "C", "D", "E", "F", "G"],
  1858: ["A", "B", "C", "D", "E1", "E2"],
  1859: ["A", "B", "C", "D", "E", "F"],
  1860: ["A", "B", "C", "D", "E", "F"],
  1861: ["A", "B", "C", "D", "E", "F"],
  1862: ["A", "B", "C", "D", "E", "F", "G"],
  1863: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1864: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
  1865: [],
  1866: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  1867: ["A", "B", "C", "D", "E1", "E2", "F"],
  1868: ["A", "B1", "B2", "C", "D", "E", "F"],
  1869: ["A", "B", "C", "D1", "D2", "E", "F"],
  1870: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1871: [],
  1872: ["A", "B", "C", "D", "E", "F", "G"],
  1873: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1874: ["A", "B", "C", "D", "E", "F", "G"],
  1875: ["A", "B", "C", "D", "E", "F", "G"],
  1876: ["A", "B", "C", "D", "E", "F", "G"],
  1877: ["A", "B", "C", "D", "E", "F", "G"],
  1878: ["A", "B", "C", "D", "E", "F", "G"],
  1879: ["A", "B", "C", "D", "E", "F"],
  1880: [],
  1881: ["A", "B", "C", "D", "E", "F", "G"],
  1882: ["A", "B", "C", "D", "E1", "E2"],
  1883: ["A", "B", "C", "D", "E", "F", "G1", "G2"],
  1884: ["A", "B", "C", "D", "E"],
  1885: ["A"],
  1886: ["A", "B", "C", "D", "E", "F"],
  1887: ["A1", "A2", "B", "C", "D", "E", "F"],
  1888: ["A", "B", "C", "D1", "D2", "E", "F"],
  1889: ["A", "B", "C1", "C2", "D", "E", "F"],
  1890: ["A", "B", "C", "D", "E1", "E2", "F"],
  1891: ["A", "B", "C", "D", "E", "F"],
  1892: [],
  1893: ["A", "B", "C", "D", "E"],
  1894: ["A", "B", "C", "D", "E"],
  1895: ["A", "B", "C", "D", "E", "F", "G"],
  1896: ["A", "B", "C", "D", "E", "F", "G", "H1", "H2"],
  1897: [],
  1898: ["A", "B", "C", "D", "E", "F"],
  1899: ["A", "B", "C", "D", "E", "F", "G"],
  1900: ["A", "B", "C", "D", "E", "F"],
  1901: ["A", "B", "C", "D", "E", "F"],
  1902: ["A", "B", "C", "D", "E", "F"],
  1903: ["A", "B", "C", "D1", "D2", "E", "F"],
  1904: ["A", "B", "C", "D1", "D2", "E", "F"],
  1905: ["A", "B", "C", "D", "E", "F"],
  1906: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  1907: ["A", "B", "C", "D", "E", "F", "G"],
  1908: [],
  1909: ["A", "B", "C", "D", "E", "F1", "F2", "G", "H", "I"],
  1910: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  1911: ["A", "B", "C", "D", "E", "F", "G", "H"],
  1912: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
  1913: ["A", "B", "C", "D", "E", "F"],
  1914: ["A", "B", "C", "D", "E1", "E2", "F", "G1", "G2"],
  1915: ["A", "B", "C", "D", "E", "F", "G"],
  1916: ["A", "B", "C", "D", "E", "F", "G", "H1", "H2"],
  1917: ["A", "B", "C", "D", "E", "F"],
  1918: ["A", "B", "C", "D", "E", "F", "G"],
  1919: ["A", "B", "C", "D", "E", "F1", "F2", "G", "H"],
  1920: ["A", "B", "C", "D", "E", "F1", "F2"],
  1921: ["A", "B", "C", "D", "E", "F", "G"],
  1922: ["A", "B", "C", "D", "E", "F"],
  1923: ["A", "B", "C", "D", "E", "F"],
  1924: ["A", "B", "C", "D", "E", "F"],
  1925: ["A", "B", "C", "D", "E", "F"],
  1926: ["A", "B", "C", "D", "E", "F", "G"],
  1927: ["A", "B", "C", "D", "E", "F", "G"],
  1928: ["A", "B", "C", "D", "E", "F"],
  1929: ["A", "B", "C", "D", "E", "F"],
  1930: ["A", "B", "C", "D1", "D2", "E", "F", "G", "H", "I"],
  1931: ["A", "B", "C", "D", "E", "F", "G"],
  1932: ["A", "B", "C", "D", "E", "F", "G"],
  1933: ["A", "B", "C", "D", "E", "F", "G"],
  1934: ["A", "B", "C", "D1", "D2", "E"],
  1935: ["A", "B", "C", "D", "E", "F"],
  1936: ["A", "B", "C", "D", "E", "F"],
  1937: ["A", "B", "C", "D", "E", "F"],
  1938: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  1939: ["A", "B", "C", "D"],
  1940: ["A", "B", "C", "D"],
};
